import React, { useState, useEffect, useRef } from 'react';
import {
  Card,
  Box,
  Alert,
  CircularProgress,
  Grid,
  Snackbar,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  TextField,
  Button,
  IconButton,
  selectClasses,
  Input, Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
} from '@mui/material';
import { CloudUpload, Delete, Add } from '@mui/icons-material';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDInput from 'components/MDInput';
import MDButton from 'components/MDButton';
import { GET, POST } from 'APIclient';
import properties from 'constants/ApplicationConstants';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { useLocation, useNavigate } from 'react-router-dom';

const StatusSelect = ({ value, onChange, disabled, error, helperText }) => (

  <FormControl fullWidth variant="standard" error={error}>
    <InputLabel shrink>
      Status
    </InputLabel>
    <Select
      value={value || ''}  // ← THIS IS THE KEY FIX
      onChange={onChange}
      disabled={disabled}
      displayEmpty
      renderValue={(selected) => {
        console.log("The value of selected", selected);
        if (!selected || selected === '') return <em style={{ color: '#999' }}>Select Status</em>;
        return selected === 'NA' ? 'N/A' : selected === 'PENDING' ? 'Pending' : 'Submitted';
      }}
    >
      <MenuItem value="" disabled>
        <em>Select Status</em>
      </MenuItem>
      <MenuItem value="NA">N/A</MenuItem>
      <MenuItem value="PENDING">Pending</MenuItem>
      <MenuItem value="SUBMITTED">Submitted</MenuItem>
    </Select>
    {helperText && (
      <Typography variant="caption" color="error" sx={{ fontSize: '0.75rem', mt: 0.5 }}>
        {helperText}
      </Typography>
    )}
  </FormControl>
);

const CommentField = ({ value, onChange, disabled, error, helperText }) => {
  const [localError, setLocalError] = useState('');

  const handleCommentChange = (e) => {
    const inputValue = e.target.value;

    // Always call onChange to update the field value
    onChange(e);

    // Check if input contains only spaces, commas, dots, or symbols
    const invalidPattern = /^[\s,.\-_!@#$%^&*()+={}[\]:;"'<>?/\\|`~]*$/;

    if (inputValue && invalidPattern.test(inputValue)) {
      setLocalError('Comment cannot contain only spaces or special characters');
    } else {
      setLocalError('');
    }
  };

  return (
    <TextField
      fullWidth
      variant="standard"
      placeholder="Enter a valid comment"
      value={value || ''}
      onChange={handleCommentChange}
      disabled={disabled}
      error={error || !!localError}
      helperText={localError || helperText || (error ? "Comment is required" : "")}
    />
  );
};


const inputStyles = {
  '& .MuiInputBase-input': {
    backgroundColor: 'transparent',
    color: 'text.primary',
    fontFamily: 'inherit',
    fontSize: '0.875rem',
  },
  '& .MuiInputBase-root': {
    backgroundColor: 'background.paper',
  }
};

// Update the AdditionalItemsSection component
const AdditionalItemsSection = ({
  section,
  items,
  formData,
  handleAdditionalItemChange,
  handleRemoveAdditionalItem,
  handleAddAdditionalItem,
  isApproved
}) => {
  const [commentErrors, setCommentErrors] = useState({});
  const [particularErrors, setParticularErrors] = useState({});

  const handleCommentChangeWithValidation = (section, index, field, value) => {
    // Always update the field value first
    handleAdditionalItemChange(section, index, field, value);

    // Then check if input contains only spaces, commas, dots, or symbols
    const invalidPattern = /^[\s,.\-_!@#$%^&*()+={}[\]:;"'<>?/\\|`~]*$/;

    if (value && invalidPattern.test(value)) {
      setCommentErrors(prev => ({
        ...prev,
        [`${section}_${index}_${field}`]: 'Comment cannot contain only spaces or special characters'
      }));
    } else {
      setCommentErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[`${section}_${index}_${field}`];
        return newErrors;
      });
    }
  };

  const handleParticularChangeWithValidation = (section, index, value) => {
    // Always update the field value first
    handleAdditionalItemChange(section, index, 'particular', value);

    // Check if input contains only spaces, commas, dots, or symbols
    const invalidPattern = /^[\s,.\-_!@#$%^&*()+={}[\]:;"'<>?/\\|`~]*$/;

    if (value && invalidPattern.test(value)) {
      setParticularErrors(prev => ({
        ...prev,
        [`${section}_${index}`]: 'Item name cannot contain only spaces or special characters'
      }));
    } else if (value && !value.trim()) {
      setParticularErrors(prev => ({
        ...prev,
        [`${section}_${index}`]: 'Item name is required'
      }));
    } else {
      setParticularErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[`${section}_${index}`];
        return newErrors;
      });
    }
  };

  return (
    <>
      {items.map((item, index) => (
        <Grid
          container
          spacing={2}
          key={index}
          sx={{ mt: 0, alignItems: 'center', borderBottom: '1px solid #e0e0e0', pb: 1 }}
        >
          <Grid item xs={12} md={3}>
            <TextField
              fullWidth
              variant="standard"
              placeholder="Enter particular"
              value={item.particular}
              onChange={(e) => handleParticularChangeWithValidation(section, index, e.target.value)}
              disabled={isApproved}
              error={!!particularErrors[`${section}_${index}`]}
              helperText={particularErrors[`${section}_${index}`] || ''}
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <FormControl fullWidth variant="standard">
              <InputLabel shrink>Status</InputLabel>
              <Select
                value={item.status || ''}
                onChange={(e) => handleAdditionalItemChange(section, index, 'status', e.target.value)}
                disabled={isApproved}
                displayEmpty
                renderValue={(selected) => {
                  if (!selected || selected === '') return <em style={{ color: '#999' }}>Select Status</em>;
                  return selected === 'NA' ? 'N/A' : selected === 'PENDING' ? 'Pending' : 'Submitted';
                }}
              >
                <MenuItem value="" disabled>
                  <em>Select Status</em>
                </MenuItem>
                <MenuItem value="NA">N/A</MenuItem>
                <MenuItem value="PENDING">Pending</MenuItem>
                <MenuItem value="SUBMITTED">Submitted</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              fullWidth
              variant="standard"
              placeholder="Enter employee comment"
              value={item.employeeComment || ''}
              onChange={(e) => handleCommentChangeWithValidation(section, index, 'employeeComment', e.target.value)}
              disabled={isApproved}
              error={!!commentErrors[`${section}_${index}_employeeComment`]}
              helperText={commentErrors[`${section}_${index}_employeeComment`] || ''}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              fullWidth
              variant="standard"
              value={item.departmentComment || ''}
              disabled
              placeholder=""
              InputProps={{
                disableUnderline: false,
                readOnly: true
              }}
              sx={{
                '& .Mui-disabled': {
                  color: 'text.secondary',
                  backgroundColor: '#f7f7f7'
                }
              }}
            />
          </Grid>
          <Grid item xs={12} md={1}>
            <IconButton
              size="small"
              onClick={() => handleRemoveAdditionalItem(section, index)}
              color="error"
              disabled={isApproved}
            >
              <Delete fontSize="small" />
            </IconButton>
          </Grid>
        </Grid>
      ))}
      <Button
        variant="outlined"
        size="small"
        startIcon={<Add />}
        onClick={() => handleAddAdditionalItem(section)}
        sx={{
          mt: 1,
          color: 'rgba(158, 97, 97, 0.93)',
          borderColor: 'black',
          '&:hover': {
            borderColor: 'black',
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
          },
        }}
        disabled={isApproved}
      >
        Add New Row
      </Button>
    </>
  );
};

const ExitClearanceForm = () => {
  const employeeId = localStorage.getItem('empId') || '';
  const dateOfLeaving = localStorage.getItem('resignationEndDate') || '';
  const dateOfJoining = localStorage.getItem("joiningDate") || '';
  const employeeName = localStorage.getItem('EmpName') || '';
  const designation = localStorage.getItem('currentDesignation') || '';
  const reportingManagerName = localStorage.getItem("reportingManagerName") || '';

  const [isEligible, setIsEligible] = useState(null);
  const [eligibilityChecking, setEligibilityChecking] = useState(true);
  const [eligibilityError, setEligibilityError] = useState('');
  const [isAlreadySubmitted, setIsAlreadySubmitted] = useState(false);
  const [existingData, setExistingData] = useState(null);
  const [isApproved, setIsApproved] = useState(false);

  const [loading, setLoading] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [snackColor, setSnackColor] = useState('success');
  const [snackMessage, setSnackMessage] = useState('');
  const [isEdited, setIsEdited] = useState(false);
  const [isDraftSaving, setIsDraftSaving] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const mode = location.state?.mode
  const isViewMode = mode == 'view' ? true : false;
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [idDraft, setIdDraft] = useState("");

  const [confirmDialogOpen, setConfirmDialogOpen] = React.useState(false);



  const [signatures, setSignatures] = useState({
    it: null,
    admin: null,
    finance: null,
    hr: null,
    employee: null
  });

  const [formData, setFormData] = useState({
    employeeName: employeeName,
    employeeId: employeeId,
    designation: designation,
    technology: '',
    projectName: '',
    projectManager: reportingManagerName || '',
    dateOfJoining: dateOfJoining,
    dateOfLeaving: dateOfLeaving,
    noticePeriodServed: '',
    knowledgeTransfer: '',

    addressLine1: '',
    addressLine2: '',
    city: '',
    state: '',
    pincode: '',
    country: '',
    acknowledgements: {
      salarySlipsCollected: '',
      form16Collected: '',
      belongingsCollected: ''
    },

    phoneNumber: '',
    alternatePhoneNumber: '',
    personalEmail: '',
    address: '',

    exitItClearance: {
      emailDeletion: '',
      empEmailIdComment: '',
      deptEmailIdComment: '',

      emailRetention: '',  // NEW
      empEmailRetentionComment: '',  // NEW
      deptEmailRetentionComment: '',  // NEW

      laptopReturned: '',
      empLaptopReturnedComment: '',
      deptLaptopReturnedComment: '',


      backupCdReturned: '',
      empBackupCdComment: '',
      deptBackupCdComment: '',


      systemLoginDeactivated: '',
      systemLoginEmpComment: '',
      systemLoginDeptComment: '',


      biometricDeleted: '',
      biometricEmpComment: '',
      biometricDeptComment: '',
      additionalItems: [],
      clearanceDate: null
    },

    exitAdministrationClearance: {
      idCard: '',
      idCardEmployeeComment: '',
      idCardDepartmentComment: '',

      drawerKeys: '',
      drawerKeysEmployeeComment: '',
      drawerKeysDepartmentComment: '',

      // accessCardDeleted: '',
      // accessCardEmployeeComment: '',
      // accessCardDepartmentComment: '',

      // companyMobile: '',
      // companyMobileEmployeeComment: '',
      // companyMobileDepartmentComment: '',

      stationery: '',
      stationeryEmployeeComment: '',
      stationeryDepartmentComment: '',
      additionalItems: [],
      clearanceDate: null
    },

    exitFinanceClearance: {
      travelReimbursement: '',
      travelReimbursementEmployeeComment: '',
      travelReimbursementDepartmentComment: '',

      guesthouseReimbursement: '',
      guesthouseReimbursementEmployeeComment: '',
      guesthouseReimbursementDepartmentComment: '',

      billsPayable: '',
      billsPayableEmployeeComment: '',
      billsPayableDepartmentComment: '',

      taxationDue: '',
      taxationDueEmployeeComment: '',
      taxationDueDepartmentComment: '',

      companyLoan: '',
      companyLoanEmployeeComment: '',
      companyLoanDepartmentComment: '',
      additionalItems: [],
      clearanceDate: null
    },

    exitHrClearance: {
      exitFormalities: '',
      exitFormalitiesEmployeeComment: '',
      exitFormalitiesDepartmentComment: '',

      documentHandover: '',
      documentHandoverEmployeeComment: '',
      documentHandoverDepartmentComment: '',
      additionalItems: [],
      clearanceDate: null
    }
  });

  const [errors, setErrors] = useState({
    employeeName: '',
    designation: '',
    technology: '',
    projectName: '',
    projectManager: '',
    noticePeriodServed: '',
    knowledgeTransfer: '',
    phoneNumber: '',
    alternatePhoneNumber: '',
    personalEmail: '',
    address: '',
    signature: ''
  });

  // Add these state variables near the top with other useState declarations
  const [noticePeriodOption, setNoticePeriodOption] = useState('');
  const [knowledgeTransferOption, setKnowledgeTransferOption] = useState('');

  // Add these handlers
  const handleNoticePeriodOptionChange = (e) => {
    if (isApproved || isViewMode) return;
    const value = e.target.value;
    setNoticePeriodOption(value);

    if (value === 'NO') {
      setFormData((prev) => ({ ...prev, noticePeriodServed: '0' }));
    } else if (value === 'YES') {
      setFormData((prev) => ({ ...prev, noticePeriodServed: '' }));
    }

    // Clear errors
    setErrors((prev) => {
      const newErrors = { ...prev };
      delete newErrors.noticePeriodServed;
      return newErrors;
    });
    setIsEdited(true);
  };

  const handleKnowledgeTransferOptionChange = (e) => {
    if (isApproved || isViewMode) return;
    const value = e.target.value;
    setKnowledgeTransferOption(value);

    if (value === 'NO') {
      setFormData((prev) => ({ ...prev, knowledgeTransfer: 'No' }));
    } else if (value === 'YES') {
      setFormData((prev) => ({ ...prev, knowledgeTransfer: '' }));
    }

    // Clear errors
    setErrors((prev) => {
      const newErrors = { ...prev };
      delete newErrors.knowledgeTransfer;
      return newErrors;
    });
    setIsEdited(true);
  };

  useEffect(() => {
    if (employeeId && dateOfLeaving) {
      checkExistingSubmission();
    } else {
      setEligibilityChecking(false);
      setIsEligible(false);
      setEligibilityError('Employee ID or resignation end date is missing.');
    }
  }, [employeeId, dateOfLeaving]);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const countryUrl = "admin/countries";
        const response = await GET(countryUrl);
        const data = response?.data?.data;
        if (data && response?.data?.statusCode === 200 && Array.isArray(data)) {
          setCountries(data);
        }
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    fetchCountries();
  }, []);


  useEffect(() => {
    const fetchStatesAndCities = async () => {
      if (formData.country) {
        try {
          const url = `admin/location-list/${formData.country}`;
          const response = await GET(url);
          if (response.status === 200) {
            const data = response.data.data;
            setStates(data);

            if (formData.state) {
              const selectedState = data.find(state => state.state === formData.state);
              setCities(selectedState ? selectedState.cities : []);
            } else {
              setCities([]);
            }
          }
        } catch (error) {
          console.error("Error fetching location data:", error);
        }
      }
    };

    fetchStatesAndCities();
  }, [formData.country]);


  const mapBackendToFrontend = (data) => {
    const contactPhone = data.contactDetails?.phoneNumber?.replace('+91-', '') || '';
    const contactAlt = data.contactDetails?.alternatePhoneNumber?.replace('+91-', '') || '';

    const mapAdditionalItems = (items) => {
      if (!items || !Array.isArray(items)) return [];
      return items.map(item => ({
        particular: item.particular || '',
        status: item.status || 'NA',
        employeeComment: item.employeeComment || '',
        departmentComment: item.departmentComment || ''
      }));
    };

    const mapped = {
      employeeName: data.employeeName || employeeName,
      employeeId: data.employeeId || employeeId,
      designation: data.designation || designation,
      technology: data.technology || '',
      projectName: data.projectName || '',
      projectManager: data.projectManager || reportingManagerName,
      dateOfJoining: dateOfJoining,
      dateOfLeaving: data.dateOfLeaving || dateOfLeaving,
      noticePeriodServed: data.noticePeriodServed?.toString() || '',
      knowledgeTransfer: data.knowledgeTransfer || '',
      phoneNumber: contactPhone,
      alternatePhoneNumber: contactAlt,
      personalEmail: data.contactDetails?.personalEmail || "",

      addressLine1: data.contactDetails?.addressLine1 || "",
      addressLine2: data.contactDetails?.addressLine2 || "",
      city: data.contactDetails?.city || "",
      state: data.contactDetails?.state || "",
      country: data.contactDetails?.country || "",
      pincode: data.contactDetails?.pincode || "",

      acknowledgements: {
        salarySlipsCollected: data.contactDetails?.salarySlipsCollected ? "YES" : "NO",
        form16Collected: data.contactDetails?.form16Collected ? "YES" : "NO",
        belongingsCollected: data.contactDetails?.belongingsCollected ? "YES" : "NO",
      },

      exitItClearance: {
        emailDeletion: data.exitItClearance?.emailIdStatus || '',
        empEmailIdComment: data.exitItClearance?.empEmailIdComment || '',
        deptEmailIdComment: data.exitItClearance?.departmentEmailIdComment || '',

        emailRetention: data.exitItClearance?.emailRetentionStatus || '',  // NEW
        empEmailRetentionComment: data.exitItClearance?.empEmailRetentionComment || '',  // NEW
        deptEmailRetentionComment: data.exitItClearance?.departmentEmailRetentionComment || '',  // NEW

        laptopReturned: data.exitItClearance?.laptopReturnedStatus || '',
        empLaptopReturnedComment: data.exitItClearance?.empLaptopReturnedComment || '',
        deptLaptopReturnedComment: data.exitItClearance?.departmentLaptopReturnedComment || '',

        backupCdReturned: data.exitItClearance?.backupCdStatus || '',
        empBackupCdComment: data.exitItClearance?.empBackupCdComment || '',
        deptBackupCdComment: data.exitItClearance?.departmentBackupCdComment || '',

        systemLoginDeactivated: data.exitItClearance?.systemLoginDeactivatedStatus || '',
        systemLoginEmpComment: data.exitItClearance?.empSystemLoginComment || '',
        systemLoginDeptComment: data.exitItClearance?.departmentSystemLoginComment || '',

        biometricDeleted: data.exitItClearance?.biometricDeletedStatus || '',
        biometricEmpComment: data.exitItClearance?.empBiometricComment || '',
        biometricDeptComment: data.exitItClearance?.departmentBiometricComment || '',
        additionalItems: mapAdditionalItems(data.exitItClearance?.additionalItems),
        clearanceDate: data.exitItClearance?.clearanceDate || null
      },

      exitAdministrationClearance: {
        idCard: data.exitAdministrationClearance?.idCardStatus || '',
        idCardEmployeeComment: data.exitAdministrationClearance?.empIdCardComment || '',
        idCardDepartmentComment: data.exitAdministrationClearance?.departmentIdCardComment || '',

        drawerKeys: data.exitAdministrationClearance?.drawerKeysStatus || '',
        drawerKeysEmployeeComment: data.exitAdministrationClearance?.empDrawerKeysComment || '',
        drawerKeysDepartmentComment: data.exitAdministrationClearance?.departmentDrawerKeysComment || '',

        accessCardDeleted: data.exitAdministrationClearance?.accessCardStatus || '',
        accessCardEmployeeComment: data.exitAdministrationClearance?.empAccessCardComment || '',
        accessCardDepartmentComment: data.exitAdministrationClearance?.departmentAccessCardComment || '',

        companyMobile: data.exitAdministrationClearance?.companyMobileStatus || '',
        companyMobileEmployeeComment: data.exitAdministrationClearance?.empCompanyMobileComment || '',
        companyMobileDepartmentComment: data.exitAdministrationClearance?.departmentCompanyMobileComment || '',

        stationery: data.exitAdministrationClearance?.stationeryStatus || '',
        stationeryEmployeeComment: data.exitAdministrationClearance?.empStationeryComment || '',
        stationeryDepartmentComment: data.exitAdministrationClearance?.departmentStationeryComment || '',
        additionalItems: mapAdditionalItems(data.exitAdministrationClearance?.additionalItems),
        clearanceDate: data.exitAdministrationClearance?.clearanceDate || null
      },

      exitFinanceClearance: {
        travelReimbursement: data.exitFinanceClearance?.travelReimbursementStatus || '',
        travelReimbursementEmployeeComment: data.exitFinanceClearance?.empTravelReimbursementComment || '',
        travelReimbursementDepartmentComment: data.exitFinanceClearance?.departmentTravelReimbursementComment || '',

        guesthouseReimbursement: data.exitFinanceClearance?.guesthouseReimbursementStatus || '',
        guesthouseReimbursementEmployeeComment: data.exitFinanceClearance?.empGuesthouseReimbursementComment || '',
        guesthouseReimbursementDepartmentComment: data.exitFinanceClearance?.departmentGuesthouseReimbursementComment || '',

        billsPayable: data.exitFinanceClearance?.billsPayableStatus || '',
        billsPayableEmployeeComment: data.exitFinanceClearance?.empBillsPayableComment || '',
        billsPayableDepartmentComment: data.exitFinanceClearance?.departmentBillsPayableComment || '',

        taxationDue: data.exitFinanceClearance?.taxationDueStatus || '',
        taxationDueEmployeeComment: data.exitFinanceClearance?.empTaxationDueComment || '',
        taxationDueDepartmentComment: data.exitFinanceClearance?.departmentTaxationDueComment || '',

        companyLoan: data.exitFinanceClearance?.companyLoanStatus || '',
        companyLoanEmployeeComment: data.exitFinanceClearance?.empCompanyLoanComment || '',
        companyLoanDepartmentComment: data.exitFinanceClearance?.departmentCompanyLoanComment || '',

        additionalItems: mapAdditionalItems(data.exitFinanceClearance?.additionalItems),
        clearanceDate: data.exitFinanceClearance?.clearanceDate || null
      },

      exitHrClearance: {
        exitFormalities: data.exitHrClearance?.hrFormalitiesStatus || '',
        exitFormalitiesEmployeeComment: data.exitHrClearance?.empExitFormalitiesComment || '',
        exitFormalitiesDepartmentComment: data.exitHrClearance?.departmentExitFormalitiesComment || '',

        documentHandover: data.exitHrClearance?.documentHandOverStatus || '',
        documentHandoverEmployeeComment: data.exitHrClearance?.empDocumentHandoverComment || '',
        documentHandoverDepartmentComment: data.exitHrClearance?.departmentDocumentHandoverComment || '',
        additionalItems: mapAdditionalItems(data.exitHrClearance?.additionalItems),
        clearanceDate: data.exitHrClearance?.clearanceDate || null
      },
    };

    if (data.noticePeriodServed) {
      const npValue = data.noticePeriodServed.toString().toLowerCase();
      if (npValue === 'no' || npValue === '0') {
        setNoticePeriodOption('0');
      } else {
        setNoticePeriodOption('YES');
      }
    }

    // Detect knowledge transfer option
    if (data.knowledgeTransfer) {
      const ktValue = data.knowledgeTransfer.toString().toLowerCase();
      if (ktValue === 'no') {
        setKnowledgeTransferOption('NO');
      } else {
        setKnowledgeTransferOption('YES');
      }
    }

    // Helper function to convert base64 to data URL
    const convertToDataURL = (base64String) => {
      if (!base64String) return null;
      if (base64String.startsWith('data:')) return base64String;
      return `data:image/png;base64,${base64String}`;
    };

    const loadedSignatures = {
      it: data.exitItClearance?.managerSignature || null,
      admin: data.exitAdministrationClearance?.managerSignature || null,
      finance: data.exitFinanceClearance?.managerSignature || null,
      hr: data.exitHrClearance?.managerSignature || null,
      employee: convertToDataURL(data.contactDetails?.signature)
    };

    return { mapped, loadedSignatures };
  };

  const checkExistingSubmission = async () => {
    setEligibilityChecking(true);
    setEligibilityError('');
    try {
      const jwtToken = window.sessionStorage.getItem('authToken') || window.sessionStorage.getItem('token');

      try {
        const getResponse = await GET(`api/exit/clearance?employeeId=${employeeId}`, {
          headers: { Authorization: `Bearer ${jwtToken}` }
        });

        await new Promise((r) => setTimeout(r, 800));

        if (getResponse.status === 200 && getResponse.data) {
          const data = getResponse.data;
          setIsAlreadySubmitted(data.draftStatus === 'submit' || data.draftStatus === 'update' ? true : false);
          setExistingData(data);

          // if(data.draftStatus!=='draft'){
          //   setIsApproved(true)
          // }

          // Check if overall status is APPROVED
          if (data.overallStatus === 'APPROVED' || data.draftStatus !== 'draft') {
            setIsApproved(true);
          }

          const { mapped, loadedSignatures } = mapBackendToFrontend(data);
          setFormData(mapped);
          setSignatures(loadedSignatures);

          setIsEligible(true);
          setEligibilityChecking(false);
          return;
        }
      } catch (err) {
        if (err.response?.status !== 404) console.error(err);
      }

      const eligibilityUrl = `api/exit/clearance/eligibility?employeeId=${employeeId}&dateOfLeaving=${dateOfLeaving}`;
      const response = await GET(eligibilityUrl, {
        headers: { Authorization: `Bearer ${window.sessionStorage.getItem('authToken') || window.sessionStorage.getItem('token')}` }
      });

      await new Promise((r) => setTimeout(r, 800));

      if (response.status === 200) {
        if (response.data.eligible) setIsEligible(true);
        else {
          setIsEligible(false);
          setEligibilityError(response.data.message || 'You are not eligible to submit exit clearance at this time.');
        }
      }
    } catch (err) {
      await new Promise((r) => setTimeout(r, 800));
      setIsEligible(false);
      setEligibilityError(err.response?.data?.message || 'Failed to check eligibility. Please try again.');
    } finally {
      setEligibilityChecking(false);
    }
  };

  const RequiredLabel = ({ children }) => (
    <MDTypography variant="caption" color="text" fontWeight="medium">
      {children}
      <span style={{ color: '#d32f2f', marginLeft: '2px' }}>*</span>
    </MDTypography>
  );

  const validateField = (name, value) => {
    let errorMessage = '';

    if (name === 'employeeName') {
      if (!value || value.toString().trim() === '') errorMessage = 'Employee name is required.';
      else if (/\d/.test(value)) errorMessage = 'Employee name should not contain numbers.';
    } else if (name === 'designation') {
      if (!value || value.toString().trim() === '') errorMessage = 'Designation is required.';
    } else if (name === 'technology') {
      if (!value || value.toString().trim() === '') errorMessage = 'Technology is required.';
    } else if (name === 'projectName') {
      if (!value || value.toString().trim() === '') errorMessage = 'Project name is required.';
    } else if (name === 'projectManager') {
      if (!value || value.toString().trim() === '') errorMessage = 'Project manager is required.';
      else if (/\d/.test(value)) errorMessage = 'Project manager name should not contain numbers.';
    } else if (name === 'dateOfJoining') {
      if (!value) errorMessage = 'Date of joining is required.';
    } else if (name === 'noticePeriodServed') {
      // Validate notice period
      if (!noticePeriodOption) {
        errorMessage = 'Please select Yes or No for notice period.';
      } else if (noticePeriodOption === 'YES') {
        if (!value || value.toString().trim() === '') {
          errorMessage = 'Please enter number of days served.';
        } else if (!/^\d+$/.test(value)) {
          errorMessage = 'Notice period must be a valid number.';
        } else if (parseInt(value) < 0) {
          errorMessage = 'Notice period cannot be negative.';
        }
      }
    } else if (name === 'knowledgeTransfer') {
      // Validate knowledge transfer
      if (!knowledgeTransferOption) {
        errorMessage = 'Please select Yes or No for knowledge transfer.';
      } else if (knowledgeTransferOption === 'YES') {
        if (!value || value.toString().trim() === '') {
          errorMessage = 'Please enter the name for knowledge transfer.';
        }
      }
    } else if (name === 'phoneNumber') {
      const phoneRegex = /^[0-9]{10}$/;
      if (!value || value.toString().trim() === '') errorMessage = 'Primary phone number is required.';
      else if (!phoneRegex.test(value)) errorMessage = 'Please enter a valid 10-digit phone number.';
    } else if (name === 'alternatePhoneNumber') {
      const phoneRegex = /^[0-9]{10}$/;
      if (value && value.toString().trim() !== '' && !phoneRegex.test(value)) errorMessage = 'Please enter a valid 10-digit phone number.';
      else if (value && value === formData.phoneNumber && formData.phoneNumber.toString().trim() !== '') errorMessage = 'Alternate phone number must be different from primary phone number.';
    } else if (name === 'personalEmail') {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!value || value.toString().trim() === '') errorMessage = 'Personal email is required.';
      else if (!emailRegex.test(value)) errorMessage = 'Please enter a valid email address.';
    } else if (name === 'address') {
      if (!value || value.toString().trim() === '') errorMessage = 'Permanent address is required.';
    }

    setErrors((prev) => ({ ...prev, [name]: errorMessage }));
    return errorMessage === '';
  };

  const handleChange = (e) => {
    if (isApproved) return; // Prevent changes if approved
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    validateField(name, value);
    setIsEdited(true);
  };

  const handleNestedChange = (section, field, value) => {
    if (isApproved) return;

    // Always update the field value first
    setFormData((prev) => ({
      ...prev,
      [section]: { ...prev[section], [field]: value }
    }));

    // Check if this is a comment field
    const isCommentField = field.toLowerCase().includes('comment');

    if (isCommentField && value) {
      // Check if input contains only spaces, commas, dots, or symbols
      const invalidPattern = /^[\s,.\-_!@#$%^&*()+={}[\]:;"'<>?/\\|`~]*$/;

      if (invalidPattern.test(value)) {
        // Set error for this specific field
        setErrors((prev) => ({
          ...prev,
          [`${section}_${field}_invalid`]: 'Comment cannot contain only spaces or special characters'
        }));
      } else {
        // Clear error for this field
        setErrors((prev) => {
          const newErrors = { ...prev };
          delete newErrors[`${section}_${field}_invalid`];
          return newErrors;
        });
      }
    }

    // Clear validation errors for this field when user types valid content
    const sectionCommentMap = {
      exitItClearance: {
        emailDeletion: 'empEmailIdComment',
        emailRetention: 'empEmailRetentionComment',
        laptopReturned: 'empLaptopReturnedComment',
        backupCdReturned: 'empBackupCdComment',
        systemLoginDeactivated: 'systemLoginEmpComment',
        biometricDeleted: 'biometricEmpComment',
      },
      exitAdministrationClearance: {
        idCard: 'idCardEmployeeComment',
        drawerKeys: 'drawerKeysEmployeeComment',
        accessCardDeleted: 'accessCardEmployeeComment',
        companyMobile: 'companyMobileEmployeeComment',
        stationery: 'stationeryEmployeeComment',
      },
      exitFinanceClearance: {
        travelReimbursement: 'travelReimbursementEmployeeComment',
        guesthouseReimbursement: 'guesthouseReimbursementEmployeeComment',
        billsPayable: 'billsPayableEmployeeComment',
        taxationDue: 'taxationDueEmployeeComment',
        companyLoan: 'companyLoanEmployeeComment',
      },
      exitHrClearance: {
        exitFormalities: 'exitFormalitiesEmployeeComment',
        documentHandover: 'documentHandoverEmployeeComment',
      }
    };

    let statusFieldName = null;
    if (sectionCommentMap[section]) {
      for (const [statusField, commentField] of Object.entries(sectionCommentMap[section])) {
        if (commentField === field) {
          statusFieldName = statusField;
          break;
        }
        if (statusField === field) {
          statusFieldName = field;
          break;
        }
      }
    }

    if (statusFieldName) {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[`${section}_${statusFieldName}_status`];
        delete newErrors[`${section}_${statusFieldName}_comment`];
        return newErrors;
      });
    }

    setIsEdited(true);
  };

  const handleDateChange = (date, field, section = null) => {
    if (isApproved) return; // Prevent changes if approved
    const validDate = date ? dayjs(date) : null;
    const formatted = validDate?.isValid() ? validDate.format('YYYY-MM-DD') : null;

    if (section) handleNestedChange(section, field, formatted);
    else {
      setFormData((prev) => ({ ...prev, [field]: formatted }));
      validateField(field, formatted);
    }
    setIsEdited(true);
  };

  const handleSignatureUpload = (section, event) => {
    if (isApproved) return; // Prevent changes if approved
    const file = event.target.files[0];
    if (file) {
      if (file.size > 2 * 1024 * 1024) {
        setSnackMessage('File size should not exceed 2MB');
        setSnackColor('error');
        setSnackOpen(true);
        return;
      }

      const reader = new FileReader();
      reader.onloadend = () => {
        setSignatures(prev => ({ ...prev, [section]: reader.result }));
        setIsEdited(true);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSignatureRemove = (section) => {
    if (isApproved) return; // Prevent changes if approved
    setSignatures(prev => ({ ...prev, [section]: null }));
    setIsEdited(true);
  };

  const handleAddAdditionalItem = (section) => {
    if (isApproved) return; // Prevent changes if approved
    setFormData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        additionalItems: [
          ...prev[section].additionalItems,
          { particular: '', status: 'NA', employeeComment: '', departmentComment: '' }
        ]
      }
    }));
    setIsEdited(true);
  };

  const handleAdditionalItemChange = (section, index, field, value) => {
    if (isApproved) return; // Prevent changes if approved
    setFormData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        additionalItems: prev[section].additionalItems.map((item, i) =>
          i === index ? { ...item, [field]: value } : item
        )
      }
    }));
    setIsEdited(true);
  };

  const handleRemoveAdditionalItem = (section, index) => {
    if (isApproved) return; // Prevent changes if approved
    setFormData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        additionalItems: prev[section].additionalItems.filter((item, i) => i !== index)
      }
    }));
    setIsEdited(true);
  };


  const handleCountryChange = (e) => {
    if (isApproved || isViewMode) return;

    const selectedCountry = e.target.value;
    console.log("The value of selected country: ", selectedCountry);
    console.log("The value of target: ", e.target);


    setStates([]);
    setCities([]);
    setFormData((prev) => ({
      ...prev,
      country: selectedCountry,
      state: "",
      city: ""
    }));
    setIsEdited(true);

    // Clear errors
    setErrors((prev) => {
      const newErrors = { ...prev };
      delete newErrors.country;
      delete newErrors.state;
      delete newErrors.city;
      return newErrors;
    });
  };

  const handleStateChange = (e) => {
    if (isApproved || isViewMode) return;

    const selectedState = e.target.value;
    setFormData((prev) => ({
      ...prev,
      state: selectedState,
      city: ""
    }));

    const stateData = states.find(state => state.state === selectedState);
    setCities(stateData ? stateData.cities : []);
    setIsEdited(true);

    // Clear errors
    setErrors((prev) => {
      const newErrors = { ...prev };
      delete newErrors.state;
      delete newErrors.city;
      return newErrors;
    });
  };

  const handleCityChange = (e) => {
    if (isApproved || isViewMode) return;

    const selectedCity = e.target.value;
    setFormData((prev) => ({
      ...prev,
      city: selectedCity
    }));
    setIsEdited(true);

    // Clear errors
    setErrors((prev) => {
      const newErrors = { ...prev };
      delete newErrors.city;
      return newErrors;
    });
  };

  const getError = (section, field, type) => errors[`${section}_${field}_${type}`] || '';


  const validateForm = () => {
    const newErrors = {};
    let isValid = true;
    const phoneRegex = /^[0-9]{10}$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const invalidCommentPattern = /^[\s,.\-_!@#$%^&*()+={}[\]:;"'<>?/\\|`~]*$/;

    if (!isAlreadySubmitted) {
      if (!formData.employeeName || formData.employeeName.toString().trim() === '') {
        newErrors.employeeName = 'Employee name is required.'; isValid = false;
      } else if (/\d/.test(formData.employeeName)) {
        newErrors.employeeName = 'Employee name should not contain numbers.'; isValid = false;
      }

      if (!formData.designation || formData.designation.toString().trim() === '') {
        newErrors.designation = 'Designation is required.'; isValid = false;
      }

      if (!formData.technology || formData.technology.toString().trim() === '') {
        newErrors.technology = 'Technology is required.'; isValid = false;
      }

      if (!formData.projectName || formData.projectName.toString().trim() === '') {
        newErrors.projectName = 'Project name is required.'; isValid = false;
      }

      if (!formData.projectManager || formData.projectManager.toString().trim() === '') {
        newErrors.projectManager = 'Project manager is required.'; isValid = false;
      } else if (/\d/.test(formData.projectManager)) {
        newErrors.projectManager = 'Project manager name should not contain numbers.'; isValid = false;
      }

      if (!formData.dateOfJoining) {
        newErrors.dateOfJoining = 'Date of joining is required.'; isValid = false;
      }

      if (!formData.noticePeriodServed || formData.noticePeriodServed.toString().trim() === '') {
        newErrors.noticePeriodServed = 'Notice period served is required.'; isValid = false;
      } else if (!/^\d+$/.test(formData.noticePeriodServed)) {
        newErrors.noticePeriodServed = 'Notice period must be a valid number.'; isValid = false;
      } else if (parseInt(formData.noticePeriodServed) < 0) {
        newErrors.noticePeriodServed = 'Notice period cannot be negative.'; isValid = false;
      }

      if (!formData.knowledgeTransfer || formData.knowledgeTransfer.toString().trim() === '') {
        newErrors.knowledgeTransfer = 'Knowledge transfer field is required.'; isValid = false;
      }
    }

    if (!formData.phoneNumber || formData.phoneNumber.toString().trim() === '') {
      newErrors.phoneNumber = 'Primary phone number is required.'; isValid = false;
    } else if (!phoneRegex.test(formData.phoneNumber)) {
      newErrors.phoneNumber = 'Please enter a valid 10-digit phone number.'; isValid = false;
    }

    if (formData.alternatePhoneNumber && formData.alternatePhoneNumber.toString().trim() !== '') {
      if (!phoneRegex.test(formData.alternatePhoneNumber)) {
        newErrors.alternatePhoneNumber = 'Please enter a valid 10-digit phone number.'; isValid = false;
      } else if (formData.alternatePhoneNumber === formData.phoneNumber) {
        newErrors.alternatePhoneNumber = 'Alternate phone number must be different from primary phone number.'; isValid = false;
      }
    }

    if (!formData.personalEmail || formData.personalEmail.toString().trim() === '') {
      newErrors.personalEmail = 'Personal email is required.'; isValid = false;
    } else if (!emailRegex.test(formData.personalEmail)) {
      newErrors.personalEmail = 'Please enter a valid email address.'; isValid = false;
    }

    if (!formData.addressLine1?.trim()) {
      newErrors.addressLine1 = 'Address Line 1 is required';
      isValid = false;
    }
    if (!formData.city?.trim()) {
      newErrors.city = 'City is required';
      isValid = false;
    }
    if (!formData.state?.trim()) {
      newErrors.state = 'State is required';
      isValid = false;
    }
    if (!formData.country?.trim()) {
      newErrors.country = 'Country is required';
      isValid = false;
    }
    if (!formData.pincode?.trim()) {
      newErrors.pincode = 'Pincode is required';
      isValid = false;
    } else if (!/^\d{6}$/.test(formData.pincode)) {
      newErrors.pincode = 'Pincode must be 6 digits';
      isValid = false;
    }

    // Acknowledgement checkboxes
    ['salarySlipsCollected', 'form16Collected', 'belongingsCollected'].forEach(key => {
      if (!formData.acknowledgements?.[key]) {
        newErrors[key] = 'This field is required';
        isValid = false;
      }
    });

    const sections = ['exitItClearance', 'exitAdministrationClearance', 'exitFinanceClearance', 'exitHrClearance'];
    sections.forEach(section => {
      formData[section].additionalItems.forEach((item, index) => {
        if (item.particular && item.particular.trim() === '') {
          newErrors[`${section}_item_${index}`] = 'Item name is required';
          isValid = false;
        }
      });
    });

    // Validate additional items particular names for invalid characters
    ['exitItClearance', 'exitAdministrationClearance', 'exitFinanceClearance', 'exitHrClearance'].forEach(section => {
      formData[section].additionalItems.forEach((item, i) => {
        const key = `${section}_item_${i}`;

        // Check if particular contains only invalid characters
        if (item.particular && invalidCommentPattern.test(item.particular)) {
          newErrors[key] = { ...(newErrors[key] || {}), particular: 'Item name cannot contain only spaces or special characters' };
          isValid = false;
        }

        // Check if particular is empty but has other fields filled
        if (!item.particular?.trim() && (item.status || item.employeeComment)) {
          newErrors[key] = { ...(newErrors[key] || {}), particular: 'Item name is required' };
          isValid = false;
        }
      });
    });

    const fixedFields = [
      { section: 'exitItClearance', items: ['emailDeletion', 'emailRetention', 'laptopReturned', 'backupCdReturned', 'systemLoginDeactivated', 'biometricDeleted'] },
      { section: 'exitAdministrationClearance', items: ['idCard', 'drawerKeys', 'stationery'] },
      { section: 'exitFinanceClearance', items: ['travelReimbursement', 'guesthouseReimbursement', 'billsPayable', 'taxationDue', 'companyLoan'] },
      { section: 'exitHrClearance', items: ['exitFormalities', 'documentHandover'] }
    ];

    const sectionCommentMap = {
      exitItClearance: {
        emailDeletion: 'empEmailIdComment',
        emailRetention: 'empEmailRetentionComment',
        laptopReturned: 'empLaptopReturnedComment',
        backupCdReturned: 'empBackupCdComment',
        systemLoginDeactivated: 'systemLoginEmpComment',
        biometricDeleted: 'biometricEmpComment',
      },
      exitAdministrationClearance: {
        idCard: 'idCardEmployeeComment',
        drawerKeys: 'drawerKeysEmployeeComment',
        // accessCardDeleted: 'accessCardEmployeeComment',
        // companyMobile: 'companyMobileEmployeeComment',
        stationery: 'stationeryEmployeeComment',
      },
      exitFinanceClearance: {
        travelReimbursement: 'travelReimbursementEmployeeComment',
        guesthouseReimbursement: 'guesthouseReimbursementEmployeeComment',
        billsPayable: 'billsPayableEmployeeComment',
        taxationDue: 'taxationDueEmployeeComment',
        companyLoan: 'companyLoanEmployeeComment',
      },
      exitHrClearance: {
        exitFormalities: 'exitFormalitiesEmployeeComment',
        documentHandover: 'documentHandoverEmployeeComment',
      }
    };

    Object.entries(sectionCommentMap).forEach(([section, fields]) => {
      Object.entries(fields).forEach(([statusField, commentField]) => {
        const comment = formData[section][commentField] || '';
        const status = formData[section][statusField];

        // Check if comment contains only invalid characters
        if (comment && invalidCommentPattern.test(comment)) {
          newErrors[`${section}_${statusField}_comment`] = 'Comment cannot contain only spaces or special characters';
          isValid = false;
        }
      });
    });

    // Validate additional items comments
    ['exitItClearance', 'exitAdministrationClearance', 'exitFinanceClearance', 'exitHrClearance'].forEach(section => {
      formData[section].additionalItems.forEach((item, i) => {
        if (item.employeeComment && invalidCommentPattern.test(item.employeeComment)) {
          const key = `${section}_item_${i}`;
          newErrors[key] = { ...(newErrors[key] || {}), comment: 'Comment cannot contain only spaces or special characters' };
          isValid = false;
        }
      });
    });


    fixedFields.forEach(({ section, items }) => {
      items.forEach(field => {
        const status = formData[section][field];
        const commentKey = sectionCommentMap[section][field];
        const comment = formData[section][commentKey] || '';

        if (!status || status === '') {
          newErrors[`${section}_${field}_status`] = 'Status is required';
          isValid = false;
        }

        if ((status === 'NA' || status === 'PENDING' || status === 'SUBMITTED') &&
          !comment.trim()) {
          newErrors[`${section}_${field}_comment`] = 'Comment is required';
          isValid = false;
        }
      });
    });


    // Also fix the additional items loop below:
    ['exitItClearance', 'exitAdministrationClearance', 'exitFinanceClearance', 'exitHrClearance'].forEach(section => {
      formData[section].additionalItems.forEach((item, i) => {
        const key = `${section}_item_${i}`;
        if (!item.status) {
          newErrors[key] = { ...(newErrors[key] || {}), status: 'Status required' };
          isValid = false;  // ← was: valid = false;
        }
        if ((item.status === 'NA' || item.status === 'PENDING' || item.status === 'SUBMITTED') && !item.employeeComment?.trim()) {
          newErrors[key] = { ...(newErrors[key] || {}), comment: 'Comment required' };
          isValid = false;  // ← was: valid = false;
        }
      });
    });



    if (!signatures.employee) {
      newErrors.signature = 'Employee signature is required.'; isValid = false;
    }


    setErrors((prev) => ({ ...prev, ...newErrors }));
    return isValid;
  };

  const mapStatusForBackend = (status) => {
    switch (status?.toUpperCase()) {
      case 'YES':
      case 'RECOVERABLE':
      case 'SUBMITTED':
      case 'APPROVED':
        return 'YES';
      case 'NO':
      case 'PENDING':
      case 'REJECTED':
        return 'NO';
      case 'NA':
      case 'N/A':
        return 'NA';
      default:
        return null;
    }
  };

  const mapToBackendStructure = (formData, signatures) => ({
    employeeName: formData.employeeName,
    employeeId: formData.employeeId,
    designation: formData.designation,
    technology: formData.technology,
    projectName: formData.projectName,
    projectManager: formData.projectManager,
    dateOfJoining: dayjs(formData.dateOfJoining).format("YYYY-MM-DD"),
    dateOfLeaving: dayjs(formData.dateOfLeaving).format("YYYY-MM-DD"),
    // Update these fields in mapToBackendStructure
    noticePeriodServed: noticePeriodOption === 'NO' ? '0' : parseInt(formData.noticePeriodServed || '0'),
    knowledgeTransfer: knowledgeTransferOption === 'NO' ? 'No' : formData.knowledgeTransfer,
    phoneNumber: `${formData.phoneNumber}`,
    alternatePhoneNumber: formData.alternatePhoneNumber ? `+91-${formData.alternatePhoneNumber}` : '',
    personalEmail: formData.personalEmail,
    addressLine1: formData.addressLine1 || '',
    addressLine2: formData.addressLine2 || '',
    city: formData.city || '',
    state: formData.state || '',
    country: formData.country || '',
    pincode: formData.pincode || '',
    signature: signatures.employee || null,
    salarySlipsCollected: formData.acknowledgements?.salarySlipsCollected === 'YES',
    form16Collected: formData.acknowledgements?.form16Collected === 'YES',
    belongingsCollected: formData.acknowledgements?.belongingsCollected === 'YES',

    exitItClearance: {
      emailIdStatus: mapStatusForBackend(formData.exitItClearance.emailDeletion),
      empEmailIdComment: formData.exitItClearance.empEmailIdComment,
      departmentEmailIdComment: formData.exitItClearance.deptEmailIdComment,
      emailRetentionStatus: mapStatusForBackend(formData.exitItClearance.emailRetention),  // NEW
      empEmailRetentionComment: formData.exitItClearance.empEmailRetentionComment,  // NEW
      departmentEmailRetentionComment: formData.exitItClearance.deptEmailRetentionComment,  // NEW
      laptopReturnedStatus: mapStatusForBackend(formData.exitItClearance.laptopReturned),
      empLaptopReturnedComment: formData.exitItClearance.empLaptopReturnedComment,
      departmentLaptopReturnedComment: formData.exitItClearance.deptLaptopReturnedComment,
      backupCdStatus: mapStatusForBackend(formData.exitItClearance.backupCdReturned),
      empBackupCdComment: formData.exitItClearance.empBackupCdComment,
      departmentBackupCdComment: formData.exitItClearance.deptBackupCdComment,
      systemLoginDeactivatedStatus: mapStatusForBackend(formData.exitItClearance.systemLoginDeactivated),
      empSystemLoginComment: formData.exitItClearance.systemLoginEmpComment,
      departmentSystemLoginComment: formData.exitItClearance.systemLoginDeptComment,
      biometricDeletedStatus: mapStatusForBackend(formData.exitItClearance.biometricDeleted),
      empBiometricComment: formData.exitItClearance.biometricEmpComment,
      departmentBiometricComment: formData.exitItClearance.biometricDeptComment,
      additionalItem: formData.exitItClearance.additionalItems,
      clearanceDate: formData.exitItClearance.clearanceDate,
      managerSignature: signatures.it || null,
      status: "PENDING"
    },

    exitAdministrationClearance: {
      idCardStatus: mapStatusForBackend(formData.exitAdministrationClearance.idCard),
      empIdCardComment: formData.exitAdministrationClearance.idCardEmployeeComment,
      departmentIdCardComment: formData.exitAdministrationClearance.idCardDepartmentComment,

      drawerKeysStatus: mapStatusForBackend(formData.exitAdministrationClearance.drawerKeys),
      empDrawerKeysComment: formData.exitAdministrationClearance.drawerKeysEmployeeComment,
      departmentDrawerKeysComment: formData.exitAdministrationClearance.drawerKeysDepartmentComment,

      // accessCardStatus: mapStatusForBackend(formData.exitAdministrationClearance.accessCardDeleted),
      // empAccessCardComment: formData.exitAdministrationClearance.accessCardEmployeeComment,
      // departmentAccessCardComment: formData.exitAdministrationClearance.accessCardDepartmentComment,

      // companyMobileStatus: mapStatusForBackend(formData.exitAdministrationClearance.companyMobile),
      // empCompanyMobileComment: formData.exitAdministrationClearance.companyMobileEmployeeComment,
      // departmentCompanyMobileComment: formData.exitAdministrationClearance.companyMobileDepartmentComment,

      stationeryStatus: mapStatusForBackend(formData.exitAdministrationClearance.stationery),
      empStationeryComment: formData.exitAdministrationClearance.stationeryEmployeeComment,
      departmentStationeryComment: formData.exitAdministrationClearance.stationeryDepartmentComment,
      additionalItems: formData.exitAdministrationClearance.additionalItems,
      clearanceDate: formData.exitAdministrationClearance.clearanceDate,
      managerSignature: signatures.admin || null,
      status: "PENDING"
    },

    exitFinanceClearance: {
      travelReimbursementStatus: mapStatusForBackend(formData.exitFinanceClearance.travelReimbursement),
      empTravelReimbursementComment: formData.exitFinanceClearance.travelReimbursementEmployeeComment,
      departmentTravelReimbursementComment: formData.exitFinanceClearance.travelReimbursementDepartmentComment,

      guesthouseReimbursementStatus: mapStatusForBackend(formData.exitFinanceClearance.guesthouseReimbursement),
      empGuesthouseReimbursementComment: formData.exitFinanceClearance.guesthouseReimbursementEmployeeComment,
      departmentGuesthouseReimbursementComment: formData.exitFinanceClearance.guesthouseReimbursementDepartmentComment,

      billsPayableStatus: mapStatusForBackend(formData.exitFinanceClearance.billsPayable),
      empBillsPayableComment: formData.exitFinanceClearance.billsPayableEmployeeComment,
      departmentBillsPayableComment: formData.exitFinanceClearance.billsPayableDepartmentComment,

      taxationDueStatus: mapStatusForBackend(formData.exitFinanceClearance.taxationDue),
      empTaxationDueComment: formData.exitFinanceClearance.taxationDueEmployeeComment,
      departmentTaxationDueComment: formData.exitFinanceClearance.taxationDueDepartmentComment,

      companyLoanStatus: mapStatusForBackend(formData.exitFinanceClearance.companyLoan),
      empCompanyLoanComment: formData.exitFinanceClearance.companyLoanEmployeeComment,
      departmentCompanyLoanComment: formData.exitFinanceClearance.companyLoanDepartmentComment,
      additionalItems: formData.exitFinanceClearance.additionalItems,
      clearanceDate: formData.exitFinanceClearance.clearanceDate,
      managerSignature: signatures.finance || null,
      status: "PENDING"
    },

    exitHrClearance: {
      hrFormalities: "Exit formalities",
      hrFormalitiesStatus: mapStatusForBackend(formData.exitHrClearance.exitFormalities),
      empExitFormalitiesComment: formData.exitHrClearance.exitFormalitiesEmployeeComment,
      departmentExitFormalitiesComment: formData.exitHrClearance.exitFormalitiesDepartmentComment,

      documentHandOver: "Document handover",
      documentHandOverStatus: mapStatusForBackend(formData.exitHrClearance.documentHandover),
      empDocumentHandoverComment: formData.exitHrClearance.documentHandoverEmployeeComment,
      departmentDocumentHandoverComment: formData.exitHrClearance.documentHandoverDepartmentComment,
      additionalItems: formData.exitHrClearance.additionalItems,
      clearanceDate: formData.exitHrClearance.clearanceDate,
      managerSignature: signatures.hr || null,
      status: "PENDING"
    }
  });

  const handleSaveDraft = async () => {
    if (isApproved) {
      setSnackMessage('Cannot save draft for approved form.');
      setSnackColor('error');
      setSnackOpen(true);
      return;
    }

    setIsDraftSaving(true);
    setLoading(true); // reuse loading state for spinner

    try {
      const jwtToken = window.sessionStorage.getItem('authToken') || window.sessionStorage.getItem('token');
      const submitData = mapToBackendStructure(formData, signatures);

      // Optionally: Add a flag to indicate it's a draft
      submitData.isDraft = "draft";

      const response = await POST('api/exit/clearance/submit', submitData, {
        headers: { Authorization: `Bearer ${jwtToken}` }
      });

      if (response.status === 200 || response.status === 201) {
        setSnackMessage('Draft saved successfully!');
        setSnackColor('success');
        setSnackOpen(true);
        setIsEdited(false);
        await checkExistingSubmission(); // Refresh data if needed
      }
    } catch (err) {
      console.error('Draft Save Error:', err);
      setSnackMessage(err.response?.data?.message || 'Failed to save draft.');
      setSnackColor('error');
      setSnackOpen(true);
    } finally {
      setIsDraftSaving(false);
      setLoading(false);
    }
  };


  const handleSubmit = (e) => {
    e.preventDefault();
    setConfirmDialogOpen(true);
  };

  const handleFinalSubmit = async () => {
    setConfirmDialogOpen(false);

    if (isApproved) {
      setSnackMessage('Cannot update an approved exit clearance form.');
      setSnackColor('error');
      setSnackOpen(true);
      return;
    }

    const isValid = validateForm();
    if (!isValid) {
      setSnackMessage('Please fill all required fields correctly.');
      setSnackColor('error');
      setSnackOpen(true);
      return;
    }

    setLoading(true);

    try {
      const jwtToken = window.sessionStorage.getItem('authToken') || window.sessionStorage.getItem('token');
      const submitData = mapToBackendStructure(formData, signatures);
      submitData.isDraft = (isAlreadySubmitted ? "update" : "submit");

      const response = await POST('api/exit/clearance/submit', submitData, {
        headers: { Authorization: `Bearer ${jwtToken}` }
      });

      if (response.status === 200 || response.status === 201) {
        setSnackMessage(isAlreadySubmitted ? 'Exit clearance updated successfully!' : 'Exit clearance submitted successfully!');
        setSnackColor('success');
        setSnackOpen(true);
        setIsEdited(false);

        await checkExistingSubmission();


        setTimeout(() => {
          navigate('/resignation');
        }, 2000);
      }
    } catch (err) {
      console.error('Submit Error:', err);
      setSnackMessage(err.response?.data?.message || 'Failed to submit exit clearance.');
      setSnackColor('error');
      setSnackOpen(true);
    } finally {
      setLoading(false);
    }
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setConfirmDialogOpen(true);

  //   if (isApproved) {
  //     setSnackMessage('Cannot update an approved exit clearance form.');
  //     setSnackColor('error');
  //     setSnackOpen(true);
  //     return;
  //   }

  //   const isValid = validateForm();
  //   if (!isValid) {
  //     setSnackMessage('Please fill all required fields correctly.');
  //     setSnackColor('error');
  //     setSnackOpen(true);
  //     return;
  //   }

  //   setLoading(true);
  //   console.log("The value of joining date: ", dateOfJoining);




  //   try {
  //     const jwtToken = window.sessionStorage.getItem('authToken') || window.sessionStorage.getItem('token');
  //     const submitData = mapToBackendStructure(formData, signatures);

  //     // setIdDraft(isAlreadySubmitted ? "update" : "submit");

  //     submitData.isDraft = (isAlreadySubmitted ? "update" : "submit");

  //     // Always use POST to /submit endpoint (works for both create and update)
  //     const response = await POST('api/exit/clearance/submit', submitData, {
  //       headers: { Authorization: `Bearer ${jwtToken}` }
  //     });

  //     if (response.status === 200 || response.status === 201) {
  //       setSnackMessage(isAlreadySubmitted ? 'Exit clearance updated successfully!' : 'Exit clearance submitted successfully!');
  //       setSnackColor('success');
  //       setSnackOpen(true);
  //       setIsEdited(false);

  //       await checkExistingSubmission();
  //     }
  //   } catch (err) {
  //     console.error('Submit Error:', err);
  //     setSnackMessage(err.response?.data?.message || 'Failed to submit exit clearance.');
  //     setSnackColor('error');
  //     setSnackOpen(true);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  if (eligibilityChecking) {
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
            <Card sx={{ p: 4, textAlign: 'center', minWidth: 400 }}>
              <CircularProgress size={60} sx={{ mb: 3 }} />
              <MDTypography variant="h6" gutterBottom>
                {isAlreadySubmitted ? 'Loading Your Submission...' : 'Checking Eligibility...'}
              </MDTypography>
              <MDTypography variant="body2" color="text.secondary">
                Please wait while we verify your exit clearance status
              </MDTypography>
            </Card>
          </Box>
        </MDBox>
      </DashboardLayout>
    );
  }

  if (isEligible === false) {
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
            <Card sx={{ p: 4, maxWidth: 600 }}>
              <Alert severity="error" sx={{ mb: 2 }}>
                <MDTypography variant="h6" gutterBottom>Not Eligible</MDTypography>
                <MDTypography variant="body2">{eligibilityError}</MDTypography>
              </Alert>
              <MDButton fullWidth variant="outlined" color="info" onClick={checkExistingSubmission} sx={{ mt: 2 }}>
                Retry
              </MDButton>
            </Card>
          </Box>
        </MDBox>
      </DashboardLayout>
    );
  }

  const ReadOnlyComment = ({ value }) => (
    <TextField
      fullWidth
      variant="standard"
      value={value || ''}
      disabled
      InputProps={{
        disableUnderline: false,
        readOnly: true
      }}
      sx={{
        '& .Mui-disabled': {
          color: 'text.secondary',
          backgroundColor: '#f7f7f7'
        }
      }}
    />
  );

  const SignatureUpload = ({ section, label, disabled }) => (
    <Box sx={{ mt: 2 }}>
      <Typography variant="body2" fontWeight="medium" mb={1}>{label}</Typography>
      {section === 'employee' ? (
        <>
          {signatures[section] ? (
            <Box sx={{ position: 'relative', display: 'inline-block' }}>
              <img
                src={signatures[section]}
                alt={label}
                style={{ maxWidth: '200px', maxHeight: '100px', border: '1px solid #ddd', borderRadius: '4px' }}
              />
              {!isApproved && (
                <IconButton
                  size="small"
                  onClick={() => handleSignatureRemove(section)}
                  sx={{ position: 'absolute', top: -10, right: -10, bgcolor: 'background.paper' }}
                >
                  <Delete fontSize="small" color="error" />
                </IconButton>
              )}
            </Box>
          ) : (
            <Button
              variant="outlined"
              component="label"
              startIcon={<CloudUpload />}
              size="small"
              disabled={isApproved || disabled}
              sx={{
                color: 'rgba(202, 24, 24, 0.52)'
              }}
            >
              Upload Signature
              <input
                type="file"
                hidden
                accept="image/*"
                onChange={(e) => handleSignatureUpload(section, e)}
              />
            </Button>
          )}
        </>
      ) : (
        <Typography
          variant="body2"
          color={signatures[section] ? 'success.main' : 'warning.main'}
          fontWeight="medium"
          sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
        >
          {signatures[section] ? (
            <>
              <span style={{ fontSize: '18px' }}>✓</span> Signature Completed
            </>
          ) : (
            <>
              <span style={{ fontSize: '18px' }}>⏳</span> Signature Pending
            </>
          )}
        </Typography>
      )}
    </Box>
  );

  const sectionCardStyle = {
    p: 2.5,
    mb: 2,
    backgroundColor: '#f5f7fa',
    borderRadius: 2,
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)'
  };

  const InfoBox = ({ label, value }) => (
    <Box>
      <MDTypography variant="caption" color="text" fontWeight="medium" mb={0.5}>
        {label}
      </MDTypography>
      <Box
        sx={{
          border: '1px solid #d0d3db',
          borderRadius: 1,
          p: 1.2,
          backgroundColor: '#e0e0e0',
          minHeight: '40px',
          display: 'flex',
          alignItems: 'center'
        }}
      >
        <MDTypography variant="body2" fontWeight="regular" color="text.primary">
          {value || 'N/A'}
        </MDTypography>
      </Box>
    </Box>
  );

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={4} pb={3}>
        <Card>
          <MDBox
            variant="gradient"
            sx={{ background: properties.colors.bgcolorbluethem }}
            bgColor="info"
            borderRadius="lg"
            coloredShadow="success"
            mx={2}
            mt={2}
            p={3}
            mb={1}
            textAlign="center"
          >
            <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>Exit Clearance Form</MDTypography>
            <MDTypography variant="body2" color="white" opacity={0.8}>
              {isApproved ? 'View Your Approved Exit Clearance' : isAlreadySubmitted ? 'Edit Your Submitted Exit Clearance' : 'Complete all required information for exit clearance'}
            </MDTypography>
          </MDBox>

          <MDBox pt={4} pb={3} px={3}>
            {isApproved && (
              <Alert severity="success" sx={{ mb: 2 }}>
                <Typography variant="body2" fontWeight="medium">
                  ✓ Your exit clearance has been submitted. No further edits are allowed.
                </Typography>
              </Alert>
            )}

            {isAlreadySubmitted && !isApproved && (
              <Alert severity="info" sx={{ mb: 2 }}>
                <Typography variant="body2">
                  Your exit clearance form has been submitted. You can edit all fields except department comments. Department signatures are view-only.
                </Typography>
              </Alert>
            )}

            <Card sx={{ p: 2, mb: 3, backgroundColor: '#fff3cd', border: '1px solid #ffc107' }}>
              <MDTypography variant="body2" color="text" textAlign="center" fontWeight="medium">
                An employee is required to return the Company&apos;s properties to the respective Department&apos;s before leaving the Company.
                He/She is instructed to bring the form to the various Departments as stated below to obtain Clearance before exit.
              </MDTypography>
            </Card>

            <form onSubmit={handleSubmit}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Card sx={sectionCardStyle}>
                    <MDTypography variant="h6" fontWeight="bold" mb={2.5} color="text.primary">
                      Employee Information
                    </MDTypography>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={4}>
                        <RequiredLabel>Name</RequiredLabel>
                        <MDInput
                          fullWidth
                          name="employeeName"
                          value={formData.employeeName}
                          onChange={handleChange}
                          error={!!errors.employeeName}
                          disabled={isApproved || isViewMode}
                          sx={inputStyles}
                        />
                        {errors.employeeName && (
                          <Typography variant="caption" color="error">{errors.employeeName}</Typography>
                        )}
                      </Grid>

                      <Grid item xs={12} md={2}>
                        <MDTypography variant="caption" color="text" fontWeight="medium" mb={0.5}>
                          Employee ID
                        </MDTypography>
                        <MDInput
                          fullWidth
                          name="employeeId"
                          value={formData.employeeId}
                          onChange={handleChange}
                          disabled={isApproved || isViewMode}
                          sx={inputStyles}
                        />
                      </Grid>

                      <Grid item xs={12} md={3}>
                        <RequiredLabel>Designation</RequiredLabel>
                        <MDInput
                          fullWidth
                          name="designation"
                          value={formData.designation}
                          onChange={handleChange}
                          error={!!errors.designation}
                          disabled={isApproved || isViewMode}
                          sx={inputStyles}
                        />
                        {errors.designation && (
                          <Typography variant="caption" color="error">{errors.designation}</Typography>
                        )}
                      </Grid>

                      <Grid item xs={12} md={3}>
                        <RequiredLabel>Technology</RequiredLabel>
                        <MDInput
                          fullWidth
                          name="technology"
                          placeholder="e.g Java, Android"
                          value={formData.technology}
                          onChange={handleChange}
                          error={!!errors.technology}
                          disabled={isApproved || isViewMode}
                          sx={inputStyles}
                        />
                        {errors.technology && (
                          <Typography variant="caption" color="error">{errors.technology}</Typography>
                        )}
                      </Grid>

                      <Grid item xs={12} md={4}>
                        <RequiredLabel>Project Name</RequiredLabel>
                        <MDInput
                          fullWidth
                          name="projectName"
                          placeholder="e.g HRM"
                          value={formData.projectName}
                          onChange={handleChange}
                          error={!!errors.projectName}
                          disabled={isApproved || isViewMode}
                          sx={inputStyles}
                        />
                        {errors.projectName && (
                          <Typography variant="caption" color="error">{errors.projectName}</Typography>
                        )}
                      </Grid>

                      <Grid item xs={12} md={4}>
                        <RequiredLabel>Reporting Manager</RequiredLabel>
                        <MDInput
                          fullWidth
                          name="projectManager"
                          value={formData.projectManager}
                          onChange={handleChange}
                          error={!!errors.projectManager}
                          disabled={isApproved || isViewMode}
                          sx={inputStyles}
                        />
                        {errors.projectManager && (
                          <Typography variant="caption" color="error">{errors.projectManager}</Typography>
                        )}
                      </Grid>

                      <Grid item xs={12} md={4}>
                        <RequiredLabel>Notice period served (yes/no)</RequiredLabel>
                        <Grid container spacing={1}>
                          <Grid item xs={4}>
                            <Box
                              sx={{
                                border: '1px solid #d0d3db',
                                borderRadius: 1,
                                backgroundColor: 'background.paper',
                                minHeight: '43.5px',
                                display: 'flex',
                                alignItems: 'center',
                                '&:hover': {
                                  borderColor: '#000',
                                },
                              }}
                            >
                              <FormControl fullWidth variant="standard">
                                <Select
                                  value={noticePeriodOption}
                                  onChange={handleNoticePeriodOptionChange}
                                  disabled={isApproved || isViewMode}
                                  displayEmpty
                                  disableUnderline
                                  sx={{
                                    px: 1.2,
                                    '& .MuiSelect-select': {
                                      backgroundColor: 'transparent',
                                      color: 'text.primary',
                                      fontFamily: 'inherit',
                                      fontSize: '0.875rem',
                                      padding: 0,
                                      minHeight: 'unset',
                                    },
                                  }}
                                >
                                  <MenuItem value="" disabled>
                                    <em>Select</em>
                                  </MenuItem>
                                  <MenuItem value="YES">Yes</MenuItem>
                                  <MenuItem value="NO">No</MenuItem>
                                </Select>
                              </FormControl>
                            </Box>
                          </Grid>
                          <Grid item xs={8}>
                            <MDInput
                              fullWidth
                              name="noticePeriodServed"
                              placeholder={noticePeriodOption === 'YES' ? "Enter number of days" : ""}
                              value={noticePeriodOption === 'NO' ? '0' : formData.noticePeriodServed}
                              onChange={handleChange}
                              error={!!errors.noticePeriodServed}
                              disabled={isApproved || isViewMode || noticePeriodOption !== 'YES'}
                              sx={inputStyles}
                            />
                          </Grid>
                        </Grid>
                        {errors.noticePeriodServed && (
                          <Typography variant="caption" color="error">{errors.noticePeriodServed}</Typography>
                        )}
                      </Grid>

                      {/* Knowledge Transfer - Updated with consistent height */}
                      <Grid item xs={12} md={4}>
                        <RequiredLabel>Knowledge Transfer To (yes/no)</RequiredLabel>
                        <Grid container spacing={1}>
                          <Grid item xs={4}>
                            <Box
                              sx={{
                                border: '1px solid #d0d3db',
                                borderRadius: 1,
                                backgroundColor: 'background.paper',
                                minHeight: '43.5px',
                                display: 'flex',
                                alignItems: 'center',
                                '&:hover': {
                                  borderColor: '#000',
                                },
                              }}
                            >
                              <FormControl fullWidth variant="standard">
                                <Select
                                  value={knowledgeTransferOption}
                                  onChange={handleKnowledgeTransferOptionChange}
                                  disabled={isApproved || isViewMode}
                                  displayEmpty
                                  disableUnderline
                                  sx={{
                                    px: 1.2,
                                    '& .MuiSelect-select': {
                                      backgroundColor: 'transparent',
                                      color: 'text.primary',
                                      fontFamily: 'inherit',
                                      fontSize: '0.875rem',
                                      padding: 0,
                                      minHeight: 'unset',
                                    },
                                  }}
                                >
                                  <MenuItem value="" disabled>
                                    <em>Select</em>
                                  </MenuItem>
                                  <MenuItem value="YES">Yes</MenuItem>
                                  <MenuItem value="NO">No</MenuItem>
                                </Select>
                              </FormControl>
                            </Box>
                          </Grid>
                          <Grid item xs={8}>
                            <MDInput
                              fullWidth
                              placeholder={knowledgeTransferOption === 'YES' ? "Enter name" : ""}
                              name="knowledgeTransfer"
                              value={knowledgeTransferOption === 'NO' ? 'No' : formData.knowledgeTransfer}
                              onChange={handleChange}
                              error={!!errors.knowledgeTransfer}
                              disabled={isApproved || isViewMode || knowledgeTransferOption !== 'YES'}
                              sx={inputStyles}
                            />
                          </Grid>
                        </Grid>
                        {errors.knowledgeTransfer && (
                          <Typography variant="caption" color="error">{errors.knowledgeTransfer}</Typography>
                        )}
                      </Grid>

                      <Grid item xs={12} md={2}>
                        <MDTypography variant="caption" color="text" fontWeight="medium" mb={0.5}>
                          DOJ
                        </MDTypography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            value={formData.dateOfJoining ? dayjs(formData.dateOfJoining) : null}
                            onChange={(date) => handleDateChange(date, 'dateOfJoining')}
                            disabled={isApproved || isViewMode}
                            format="DD MMM YY"
                            slotProps={{
                              textField: {
                                fullWidth: true,
                                variant: 'outlined',
                                sx: inputStyles
                              }
                            }}
                          />
                        </LocalizationProvider>
                      </Grid>

                      <Grid item xs={12} md={2}>
                        <MDTypography variant="caption" color="text" fontWeight="medium" mb={0.5}>
                          DOL
                        </MDTypography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            value={formData.dateOfLeaving ? dayjs(formData.dateOfLeaving) : null}
                            onChange={(date) => handleDateChange(date, 'dateOfLeaving')}
                            disabled={isApproved || isViewMode}
                            format="DD MMM YY"
                            slotProps={{
                              textField: {
                                fullWidth: true,
                                variant: 'outlined',
                                sx: inputStyles
                              }
                            }}
                          />
                        </LocalizationProvider>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>

                <Grid item xs={12}>
                  <Card sx={{ p: 2, mb: 2, backgroundColor: '#e7f3ff', border: '1px solid #2196f3' }}>
                    <MDTypography variant="body2" color="text" fontWeight="medium">
                      Person in-charge is required to sign-off in the respective sections mentioned below. Advising team and Reporting Manager should sign after rest of the clearances.
                    </MDTypography>
                  </Card>
                </Grid>

                <Grid item xs={12}>
                  <Card sx={sectionCardStyle}>
                    <MDTypography variant="h6" fontWeight="bold" color="text.primary">
                      IT Department Clearance
                    </MDTypography>
                    <MDTypography variant="caption" color="text.secondary">
                      Please submit all following things to concern departments.
                    </MDTypography>

                    <Grid container spacing={2} sx={{ mt: 2 }}>
                      {/* Table Header */}
                      <Grid item xs={12} md={3}><Typography variant="body2" fontWeight="bold">Particulars</Typography></Grid>
                      <Grid item xs={12} md={2}><Typography variant="body2" fontWeight="bold">Status <span style={{ color: '#d32f2f' }}>*</span></Typography></Grid>
                      <Grid item xs={12} md={3}><Typography variant="body2" fontWeight="bold">Employee Comment <span style={{ color: '#d32f2f' }}>*</span></Typography></Grid>
                      <Grid item xs={12} md={4}><Typography variant="body2" fontWeight="bold">Department Comment</Typography></Grid>

                      {/* Email Deletion */}
                      <Grid item xs={12} md={3}><Typography variant="body2">Deletion of email id</Typography></Grid>
                      <Grid item xs={12} md={2}>
                        <StatusSelect
                          value={formData.exitItClearance.emailDeletion}
                          onChange={(e) => handleNestedChange('exitItClearance', 'emailDeletion', e.target.value)}
                          disabled={isApproved || isViewMode}
                          error={!!getError('exitItClearance', 'emailDeletion', 'status')}
                          helperText={getError('exitItClearance', 'emailDeletion', 'status')}
                        />
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <CommentField
                          value={formData.exitItClearance.empEmailIdComment || ''}
                          onChange={(e) => handleNestedChange('exitItClearance', 'empEmailIdComment', e.target.value)}
                          disabled={isApproved || isViewMode}
                          error={!!getError('exitItClearance', 'emailDeletion', 'comment')}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <ReadOnlyComment value={formData.exitItClearance.deptEmailIdComment} />
                      </Grid>

                      {/* Email Retention */}
                      <Grid item xs={12} md={3}><Typography variant="body2">Retention of email id</Typography></Grid>
                      <Grid item xs={12} md={2}>
                        <StatusSelect
                          value={formData.exitItClearance.emailRetention}
                          onChange={(e) => handleNestedChange('exitItClearance', 'emailRetention', e.target.value)}
                          disabled={isApproved || isViewMode}
                          error={!!getError('exitItClearance', 'emailRetention', 'status')}
                          helperText={getError('exitItClearance', 'emailRetention', 'status')}
                        />
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <CommentField
                          value={formData.exitItClearance.empEmailRetentionComment || ''}
                          onChange={(e) => handleNestedChange('exitItClearance', 'empEmailRetentionComment', e.target.value)}
                          disabled={isApproved || isViewMode}
                          error={!!getError('exitItClearance', 'emailRetention', 'comment')}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <ReadOnlyComment value={formData.exitItClearance.deptEmailRetentionComment} />
                      </Grid>

                      {/* Laptop Returned */}
                      <Grid item xs={12} md={3}><Typography variant="body2">Laptop, Mouse, Charger returned</Typography></Grid>
                      <Grid item xs={12} md={2}>
                        <StatusSelect
                          value={formData.exitItClearance.laptopReturned}
                          onChange={(e) => handleNestedChange('exitItClearance', 'laptopReturned', e.target.value)}
                          disabled={isApproved || isViewMode}
                          error={!!getError('exitItClearance', 'laptopReturned', 'status')}
                          helperText={getError('exitItClearance', 'laptopReturned', 'status')}
                        />
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <CommentField
                          value={formData.exitItClearance.empLaptopReturnedComment || ''}
                          onChange={(e) => handleNestedChange('exitItClearance', 'empLaptopReturnedComment', e.target.value)}
                          disabled={isApproved || isViewMode}
                          error={!!getError('exitItClearance', 'laptopReturned', 'comment')}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <ReadOnlyComment value={formData.exitItClearance.deptLaptopReturnedComment} />
                      </Grid>

                      {/* System Login Deactivated */}
                      <Grid item xs={12} md={3}><Typography variant="body2">System login id deactivated</Typography></Grid>
                      <Grid item xs={12} md={2}>
                        <StatusSelect
                          value={formData.exitItClearance.systemLoginDeactivated}
                          onChange={(e) => handleNestedChange('exitItClearance', 'systemLoginDeactivated', e.target.value)}
                          disabled={isApproved || isViewMode}
                          error={!!getError('exitItClearance', 'systemLoginDeactivated', 'status')}
                          helperText={getError('exitItClearance', 'systemLoginDeactivated', 'status')}
                        />
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <CommentField
                          value={formData.exitItClearance.systemLoginEmpComment || ''}
                          onChange={(e) => handleNestedChange('exitItClearance', 'systemLoginEmpComment', e.target.value)}
                          disabled={isApproved || isViewMode}
                          error={!!getError('exitItClearance', 'systemLoginDeactivated', 'comment')}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <ReadOnlyComment value={formData.exitItClearance.systemLoginDeptComment} />
                      </Grid>

                      {/* Biometric Deleted */}
                      <Grid item xs={12} md={3}><Typography variant="body2">Biometric entry (delete)</Typography></Grid>
                      <Grid item xs={12} md={2}>
                        <StatusSelect
                          value={formData.exitItClearance.biometricDeleted}
                          onChange={(e) => handleNestedChange('exitItClearance', 'biometricDeleted', e.target.value)}
                          disabled={isApproved || isViewMode}
                          error={!!getError('exitItClearance', 'biometricDeleted', 'status')}
                          helperText={getError('exitItClearance', 'biometricDeleted', 'status')}
                        />
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <CommentField
                          value={formData.exitItClearance.biometricEmpComment || ''}
                          onChange={(e) => handleNestedChange('exitItClearance', 'biometricEmpComment', e.target.value)}
                          disabled={isApproved || isViewMode}
                          error={!!getError('exitItClearance', 'biometricDeleted', 'comment')}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <ReadOnlyComment value={formData.exitItClearance.biometricDeptComment} />
                      </Grid>

                      {/* Backup CD Returned */}
                      <Grid item xs={12} md={3}><Typography variant="body2">Company Mobile/Devices submitted</Typography></Grid>
                      <Grid item xs={12} md={2}>
                        <StatusSelect
                          value={formData.exitItClearance.backupCdReturned}
                          onChange={(e) => handleNestedChange('exitItClearance', 'backupCdReturned', e.target.value)}
                          disabled={isApproved || isViewMode}
                          error={!!getError('exitItClearance', 'backupCdReturned', 'status')}
                          helperText={getError('exitItClearance', 'backupCdReturned', 'status')}
                        />
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <CommentField
                          value={formData.exitItClearance.empBackupCdComment || ''}
                          onChange={(e) => handleNestedChange('exitItClearance', 'empBackupCdComment', e.target.value)}
                          disabled={isApproved || isViewMode}
                          error={!!getError('exitItClearance', 'backupCdReturned', 'comment')}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <ReadOnlyComment value={formData.exitItClearance.deptBackupCdComment} />
                      </Grid>

                      {/* Additional Items */}
                      <Grid item xs={12}>
                        <AdditionalItemsSection
                          section="exitItClearance"
                          items={formData.exitItClearance.additionalItems}
                          handleAdditionalItemChange={handleAdditionalItemChange}
                          handleRemoveAdditionalItem={handleRemoveAdditionalItem}
                          handleAddAdditionalItem={handleAddAdditionalItem}
                          isApproved={isApproved || isViewMode}
                          errors={errors}
                        />
                      </Grid>

                      {/* Clearance Date & Signature */}
                      <Grid item xs={12} md={6}>
                        <MDTypography variant="caption" color="text" fontWeight="medium">Clearance Date</MDTypography>
                        <TextField
                          fullWidth
                          variant="standard"
                          value={
                            formData.exitItClearance.clearanceDate
                              ? new Date(formData.exitItClearance.clearanceDate).toLocaleDateString('en-GB', {
                                day: '2-digit', month: 'short', year: '2-digit'
                              })
                              : 'N/A'
                          }
                          disabled
                          InputProps={{ readOnly: true }}
                          sx={{ '& .Mui-disabled': { color: 'text.secondary', backgroundColor: '#f7f7f7' } }}
                        />
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <SignatureUpload section="it" label="IT Manager Signature" />
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>

                <Grid item xs={12}>
                  <Card sx={sectionCardStyle}>
                    <MDTypography variant="h6" fontWeight="bold" color="text.primary">
                      Administration Clearance
                    </MDTypography>
                    <MDTypography variant="caption" color="text.secondary">
                      Please return all issued items to Administration.
                    </MDTypography>

                    <Grid container spacing={2} sx={{ mt: 2 }}>
                      {/* Table Header */}
                      <Grid item xs={12} md={3}><Typography variant="body2" fontWeight="bold">Particulars</Typography></Grid>
                      <Grid item xs={12} md={2}><Typography variant="body2" fontWeight="bold">Status <span style={{ color: '#d32f2f' }}>*</span></Typography></Grid>
                      <Grid item xs={12} md={3}><Typography variant="body2" fontWeight="bold">Employee Comment <span style={{ color: '#d32f2f' }}>*</span></Typography></Grid>
                      <Grid item xs={12} md={4}><Typography variant="body2" fontWeight="bold">Department Comment</Typography></Grid>

                      {/* ID Card */}
                      <Grid item xs={12} md={3}><Typography variant="body2">Id card</Typography></Grid>
                      <Grid item xs={12} md={2}>
                        <StatusSelect
                          value={formData.exitAdministrationClearance.idCard}
                          onChange={(e) => handleNestedChange('exitAdministrationClearance', 'idCard', e.target.value)}
                          disabled={isApproved || isViewMode}
                          error={!!getError('exitAdministrationClearance', 'idCard', 'status')}
                          helperText={getError('exitAdministrationClearance', 'idCard', 'status')}
                        />
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <CommentField
                          value={formData.exitAdministrationClearance.idCardEmployeeComment || ''}
                          onChange={(e) => handleNestedChange('exitAdministrationClearance', 'idCardEmployeeComment', e.target.value)}
                          disabled={isApproved || isViewMode}
                          error={!!getError('exitAdministrationClearance', 'idCard', 'comment')}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <ReadOnlyComment value={formData.exitAdministrationClearance.idCardDepartmentComment} />
                      </Grid>

                      {/* Drawer Keys */}
                      <Grid item xs={12} md={3}><Typography variant="body2">Drawer keys</Typography></Grid>
                      <Grid item xs={12} md={2}>
                        <StatusSelect
                          value={formData.exitAdministrationClearance.drawerKeys}
                          onChange={(e) => handleNestedChange('exitAdministrationClearance', 'drawerKeys', e.target.value)}
                          disabled={isApproved || isViewMode}
                          error={!!getError('exitAdministrationClearance', 'drawerKeys', 'status')}
                          helperText={getError('exitAdministrationClearance', 'drawerKeys', 'status')}
                        />
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <CommentField
                          value={formData.exitAdministrationClearance.drawerKeysEmployeeComment || ''}
                          onChange={(e) => handleNestedChange('exitAdministrationClearance', 'drawerKeysEmployeeComment', e.target.value)}
                          disabled={isApproved || isViewMode}
                          error={!!getError('exitAdministrationClearance', 'drawerKeys', 'comment')}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <ReadOnlyComment value={formData.exitAdministrationClearance.drawerKeysDepartmentComment} />
                      </Grid>

                      {/* Access Card / Biometric */}
                      {/* <Grid item xs={12} md={3}><Typography variant="body2">Access cards / Biometric Impression (to be deleted)</Typography></Grid>
                      <Grid item xs={12} md={2}>
                        <StatusSelect
                          value={formData.exitAdministrationClearance.accessCardDeleted}
                          onChange={(e) => handleNestedChange('exitAdministrationClearance', 'accessCardDeleted', e.target.value)}
                          disabled={isApproved || isViewMode}
                          error={!!getError('exitAdministrationClearance', 'accessCardDeleted', 'status')}
                          helperText={getError('exitAdministrationClearance', 'accessCardDeleted', 'status')}
                        />
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <CommentField
                          value={formData.exitAdministrationClearance.accessCardEmployeeComment || ''}
                          onChange={(e) => handleNestedChange('exitAdministrationClearance', 'accessCardEmployeeComment', e.target.value)}
                          disabled={isApproved || isViewMode}
                          error={!!getError('exitAdministrationClearance', 'accessCardDeleted', 'comment')}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <ReadOnlyComment value={formData.exitAdministrationClearance.accessCardDepartmentComment} />
                      </Grid> */}

                      {/* Company Mobile */}
                      {/* <Grid item xs={12} md={3}><Typography variant="body2">Company mobile phone</Typography></Grid>
                      <Grid item xs={12} md={2}>
                        <StatusSelect
                          value={formData.exitAdministrationClearance.companyMobile}
                          onChange={(e) => handleNestedChange('exitAdministrationClearance', 'companyMobile', e.target.value)}
                          disabled={isApproved || isViewMode}
                          error={!!getError('exitAdministrationClearance', 'companyMobile', 'status')}
                          helperText={getError('exitAdministrationClearance', 'companyMobile', 'status')}
                        />
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <CommentField
                          value={formData.exitAdministrationClearance.companyMobileEmployeeComment || ''}
                          onChange={(e) => handleNestedChange('exitAdministrationClearance', 'companyMobileEmployeeComment', e.target.value)}
                          disabled={isApproved || isViewMode}
                          error={!!getError('exitAdministrationClearance', 'companyMobile', 'comment')}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <ReadOnlyComment value={formData.exitAdministrationClearance.companyMobileDepartmentComment} />
                      </Grid> */}

                      {/* Stationery */}
                      <Grid item xs={12} md={3}><Typography variant="body2">Stationery</Typography></Grid>
                      <Grid item xs={12} md={2}>
                        <StatusSelect
                          value={formData.exitAdministrationClearance.stationery}
                          onChange={(e) => handleNestedChange('exitAdministrationClearance', 'stationery', e.target.value)}
                          disabled={isApproved || isViewMode}
                          error={!!getError('exitAdministrationClearance', 'stationery', 'status')}
                          helperText={getError('exitAdministrationClearance', 'stationery', 'status')}
                        />
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <CommentField
                          value={formData.exitAdministrationClearance.stationeryEmployeeComment || ''}
                          onChange={(e) => handleNestedChange('exitAdministrationClearance', 'stationeryEmployeeComment', e.target.value)}
                          disabled={isApproved || isViewMode}
                          error={!!getError('exitAdministrationClearance', 'stationery', 'comment')}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <ReadOnlyComment value={formData.exitAdministrationClearance.stationeryDepartmentComment} />
                      </Grid>

                      {/* Additional Items */}
                      <Grid item xs={12}>
                        <AdditionalItemsSection
                          section="exitAdministrationClearance"
                          items={formData.exitAdministrationClearance.additionalItems}
                          formData={formData}
                          handleAdditionalItemChange={handleAdditionalItemChange}
                          handleRemoveAdditionalItem={handleRemoveAdditionalItem}
                          handleAddAdditionalItem={handleAddAdditionalItem}
                          isApproved={isApproved || isViewMode}
                        />
                      </Grid>

                      {/* Clearance Date (optional – you can add if backend returns it) */}
                      {/* <Grid item xs={12} md={6}>
      <MDTypography variant="caption" color="text" fontWeight="medium">Clearance Date</MDTypography>
      <TextField ... />
    </Grid> */}

                      {/* Admin Signature */}
                      <Grid item xs={12} md={6}>
                        <SignatureUpload section="admin" label="Admin Manager's Signature" />
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>

                <Grid item xs={12}>
                  <Card sx={sectionCardStyle}>
                    <MDTypography variant="h6" fontWeight="bold" color="text.primary">
                      Finance Clearance
                    </MDTypography>
                    <MDTypography variant="caption" color="text.secondary">
                      Please clear all pending recoverable dues before final settlement.
                    </MDTypography>

                    <Grid container spacing={2} sx={{ mt: 2 }}>
                      {/* Table Header */}
                      <Grid item xs={12} md={3}><Typography variant="body2" fontWeight="bold">Particulars</Typography></Grid>
                      <Grid item xs={12} md={2}><Typography variant="body2" fontWeight="bold">Status <span style={{ color: '#d32f2f' }}>*</span></Typography></Grid>
                      <Grid item xs={12} md={3}><Typography variant="body2" fontWeight="bold">Employee Comment <span style={{ color: '#d32f2f' }}>*</span></Typography></Grid>
                      <Grid item xs={12} md={4}><Typography variant="body2" fontWeight="bold">Department Comment</Typography></Grid>

                      {/* Travel Reimbursement */}
                      <Grid item xs={12} md={3}><Typography variant="body2">Travel reimbursement</Typography></Grid>
                      <Grid item xs={12} md={2}>
                        <StatusSelect
                          value={formData.exitFinanceClearance.travelReimbursement}
                          onChange={(e) => handleNestedChange('exitFinanceClearance', 'travelReimbursement', e.target.value)}
                          disabled={isApproved || isViewMode}
                          error={!!getError('exitFinanceClearance', 'travelReimbursement', 'status')}
                          helperText={getError('exitFinanceClearance', 'travelReimbursement', 'status')}
                        />
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <CommentField
                          value={formData.exitFinanceClearance.travelReimbursementEmployeeComment || ''}
                          onChange={(e) => handleNestedChange('exitFinanceClearance', 'travelReimbursementEmployeeComment', e.target.value)}
                          disabled={isApproved || isViewMode}
                          error={!!getError('exitFinanceClearance', 'travelReimbursement', 'comment')}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <ReadOnlyComment value={formData.exitFinanceClearance.travelReimbursementDepartmentComment} />
                      </Grid>

                      {/* Guesthouse Reimbursement */}
                      <Grid item xs={12} md={3}><Typography variant="body2">Guesthouse reimbursement</Typography></Grid>
                      <Grid item xs={12} md={2}>
                        <StatusSelect
                          value={formData.exitFinanceClearance.guesthouseReimbursement}
                          onChange={(e) => handleNestedChange('exitFinanceClearance', 'guesthouseReimbursement', e.target.value)}
                          disabled={isApproved || isViewMode}
                          error={!!getError('exitFinanceClearance', 'guesthouseReimbursement', 'status')}
                          helperText={getError('exitFinanceClearance', 'guesthouseReimbursement', 'status')}
                        />
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <CommentField
                          value={formData.exitFinanceClearance.guesthouseReimbursementEmployeeComment || ''}
                          onChange={(e) => handleNestedChange('exitFinanceClearance', 'guesthouseReimbursementEmployeeComment', e.target.value)}
                          disabled={isApproved || isViewMode}
                          error={!!getError('exitFinanceClearance', 'guesthouseReimbursement', 'comment')}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <ReadOnlyComment value={formData.exitFinanceClearance.guesthouseReimbursementDepartmentComment} />
                      </Grid>

                      {/* Bills Payable / Per Diem Dues */}
                      <Grid item xs={12} md={3}><Typography variant="body2">Bills payable / per diem dues</Typography></Grid>
                      <Grid item xs={12} md={2}>
                        <StatusSelect
                          value={formData.exitFinanceClearance.billsPayable}
                          onChange={(e) => handleNestedChange('exitFinanceClearance', 'billsPayable', e.target.value)}
                          disabled={isApproved || isViewMode}
                          error={!!getError('exitFinanceClearance', 'billsPayable', 'status')}
                          helperText={getError('exitFinanceClearance', 'billsPayable', 'status')}
                        />
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <CommentField
                          value={formData.exitFinanceClearance.billsPayableEmployeeComment || ''}
                          onChange={(e) => handleNestedChange('exitFinanceClearance', 'billsPayableEmployeeComment', e.target.value)}
                          disabled={isApproved || isViewMode}
                          error={!!getError('exitFinanceClearance', 'billsPayable', 'comment')}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <ReadOnlyComment value={formData.exitFinanceClearance.billsPayableDepartmentComment} />
                      </Grid>

                      {/* Taxation Due */}
                      <Grid item xs={12} md={3}><Typography variant="body2">Taxation due</Typography></Grid>
                      <Grid item xs={12} md={2}>
                        <StatusSelect
                          value={formData.exitFinanceClearance.taxationDue}
                          onChange={(e) => handleNestedChange('exitFinanceClearance', 'taxationDue', e.target.value)}
                          disabled={isApproved || isViewMode}
                          error={!!getError('exitFinanceClearance', 'taxationDue', 'status')}
                          helperText={getError('exitFinanceClearance', 'taxationDue', 'status')}
                        />
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <CommentField
                          value={formData.exitFinanceClearance.taxationDueEmployeeComment || ''}
                          onChange={(e) => handleNestedChange('exitFinanceClearance', 'taxationDueEmployeeComment', e.target.value)}
                          disabled={isApproved || isViewMode}
                          error={!!getError('exitFinanceClearance', 'taxationDue', 'comment')}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <ReadOnlyComment value={formData.exitFinanceClearance.taxationDueDepartmentComment} />
                      </Grid>

                      {/* Company Loan / Advances */}
                      <Grid item xs={12} md={3}><Typography variant="body2">Company loan / advances</Typography></Grid>
                      <Grid item xs={12} md={2}>
                        <StatusSelect
                          value={formData.exitFinanceClearance.companyLoan}
                          onChange={(e) => handleNestedChange('exitFinanceClearance', 'companyLoan', e.target.value)}
                          disabled={isApproved || isViewMode}
                          error={!!getError('exitFinanceClearance', 'companyLoan', 'status')}
                          helperText={getError('exitFinanceClearance', 'companyLoan', 'status')}
                        />
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <CommentField
                          value={formData.exitFinanceClearance.companyLoanEmployeeComment || ''}
                          onChange={(e) => handleNestedChange('exitFinanceClearance', 'companyLoanEmployeeComment', e.target.value)}
                          disabled={isApproved || isViewMode}
                          error={!!getError('exitFinanceClearance', 'companyLoan', 'comment')}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <ReadOnlyComment value={formData.exitFinanceClearance.companyLoanDepartmentComment} />
                      </Grid>

                      {/* Additional Items */}
                      <Grid item xs={12}>
                        <AdditionalItemsSection
                          section="exitFinanceClearance"
                          items={formData.exitFinanceClearance.additionalItems}
                          formData={formData}
                          handleAdditionalItemChange={handleAdditionalItemChange}
                          handleRemoveAdditionalItem={handleRemoveAdditionalItem}
                          handleAddAdditionalItem={handleAddAdditionalItem}
                          isApproved={isApproved || isViewMode}
                        />
                      </Grid>

                      {/* Finance Manager Signature */}
                      <Grid item xs={12} md={6}>
                        <SignatureUpload section="finance" label="Finance Manager's Signature" />
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>

                <Grid item xs={12}>
                  <Card sx={sectionCardStyle}>
                    <MDTypography variant="h6" fontWeight="bold" color="text.primary">
                      HR Clearance
                    </MDTypography>
                    <MDTypography variant="caption" color="text.secondary" sx={{ mb: 2 }}>
                      Please complete all HR formalities and document handover.
                    </MDTypography>

                    <Grid container spacing={2} sx={{ mt: 2 }}>
                      {/* Table Header */}
                      <Grid item xs={12} md={3}><Typography variant="body2" fontWeight="bold">Particulars</Typography></Grid>
                      <Grid item xs={12} md={2}><Typography variant="body2" fontWeight="bold">Status <span style={{ color: '#d32f2f' }}>*</span></Typography></Grid>
                      <Grid item xs={12} md={3}><Typography variant="body2" fontWeight="bold">Employee Comment <span style={{ color: '#d32f2f' }}>*</span></Typography></Grid>
                      <Grid item xs={12} md={4}><Typography variant="body2" fontWeight="bold">Department Comment</Typography></Grid>

                      {/* HR Formalities Completed */}
                      <Grid item xs={12} md={3}>
                        <Typography variant="body2">Submitted Clearance form</Typography>
                      </Grid>
                      <Grid item xs={12} md={2}>
                        <StatusSelect
                          value={formData.exitHrClearance.exitFormalities}
                          onChange={(e) => handleNestedChange('exitHrClearance', 'exitFormalities', e.target.value)}
                          disabled={isApproved || isViewMode}
                          error={!!getError('exitHrClearance', 'exitFormalities', 'status')}
                          helperText={getError('exitHrClearance', 'exitFormalities', 'status')}
                        />
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <CommentField
                          value={formData.exitHrClearance.exitFormalitiesEmployeeComment || ''}
                          onChange={(e) => handleNestedChange('exitHrClearance', 'exitFormalitiesEmployeeComment', e.target.value)}
                          disabled={isApproved || isViewMode}
                          error={!!getError('exitHrClearance', 'exitFormalities', 'comment')}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <ReadOnlyComment value={formData.exitHrClearance.exitFormalitiesDepartmentComment} />
                      </Grid>

                      {/* Document Handover Done */}
                      <Grid item xs={12} md={3}>
                        <Typography variant="body2">Submitted exit Interview form</Typography>
                      </Grid>
                      <Grid item xs={12} md={2}>
                        <StatusSelect
                          value={formData.exitHrClearance.documentHandover}
                          onChange={(e) => handleNestedChange('exitHrClearance', 'documentHandover', e.target.value)}
                          disabled={isApproved || isViewMode}
                          error={!!getError('exitHrClearance', 'documentHandover', 'status')}
                          helperText={getError('exitHrClearance', 'documentHandover', 'status')}
                        />
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <CommentField
                          value={formData.exitHrClearance.documentHandoverEmployeeComment || ''}
                          onChange={(e) => handleNestedChange('exitHrClearance', 'documentHandoverEmployeeComment', e.target.value)}
                          disabled={isApproved || isViewMode}
                          error={!!getError('exitHrClearance', 'documentHandover', 'comment')}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <ReadOnlyComment value={formData.exitHrClearance.documentHandoverDepartmentComment} />
                      </Grid>

                      {/* Additional Items */}
                      <Grid item xs={12}>
                        <AdditionalItemsSection
                          section="exitHrClearance"
                          items={formData.exitHrClearance.additionalItems}
                          formData={formData}
                          handleAdditionalItemChange={handleAdditionalItemChange}
                          handleRemoveAdditionalItem={handleRemoveAdditionalItem}
                          handleAddAdditionalItem={handleAddAdditionalItem}
                          isApproved={isApproved || isViewMode}
                        />
                      </Grid>

                      {/* HR Manager Signature */}
                      <Grid item xs={12} md={6}>
                        <SignatureUpload section="hr" label="HR Manager's Signature" />
                      </Grid>
                    </Grid>

                    {/* Important Note Box */}
                    <Box sx={{ mt: 3, p: 2, backgroundColor: '#fff3cd', border: '1px solid #ffc107', borderRadius: 1 }}>
                      <MDTypography variant="body2" color="text">
                        <strong>Note:</strong> In case you shall be closing your salary account please inform us with alternate account details. Your F&F will be done in the following month. You will be requested to visit BNT and collect your F&F cheque and sign the F&F document. Also you will be requested to personally collect copy of your relieving letter from office.
                      </MDTypography>
                      <MDTypography variant="body2" color="text" sx={{ mt: 0.5 }}>
                        • Kindly make a note of your Paysquare user ID and password or please regenerate as you may require it post your exit.
                      </MDTypography>
                    </Box>
                    {/* New Acknowledgment Checkboxes */}
                    <Box sx={{ mt: 4, pl: 2 }}>
                      <MDTypography variant="h6" fontWeight="bold" color="text.primary" gutterBottom>
                        Acknowledgement <span style={{ color: '#d32f2f' }}>*</span>
                      </MDTypography>
                      <Grid container spacing={3}>
                        {[
                          { label: "Please collect all your salary slips from Paysquare.", key: "salarySlipsCollected" },
                          { label: "Please collect your previous years Form 16 from Paysquare portal.", key: "form16Collected" },
                          { label: "Please collect all your personal belongings. No one shall be held responsible for any forgotten item.", key: "belongingsCollected" }
                        ].map((item) => (
                          <Grid item xs={12} key={item.key}>
                            <FormControl component="fieldset" error={errors[item.key]}>
                              <Grid container alignItems="center" spacing={2}>
                                <Grid item>
                                  <Typography variant="body2">{item.label}  <span style={{ color: '#d32f2f' }}>*</span></Typography>
                                </Grid>
                                <Grid item>
                                  <Select
                                    value={formData.acknowledgements?.[item.key] || ''}
                                    onChange={(e) => handleNestedChange('acknowledgements', item.key, e.target.value)}
                                    disabled={isApproved || isViewMode}
                                    displayEmpty
                                    size="small"
                                    sx={{ minWidth: 120 }}
                                  >
                                    <MenuItem value="" disabled><em>Select</em></MenuItem>
                                    <MenuItem value="YES">Yes</MenuItem>
                                    <MenuItem value="NO">No</MenuItem>
                                  </Select>
                                </Grid>
                              </Grid>
                              {errors[item.key] && (
                                <Typography variant="caption" color="error" sx={{ ml: 2, mt: 0.5 }}>
                                  {errors[item.key]}
                                </Typography>
                              )}
                            </FormControl>
                          </Grid>
                        ))}
                      </Grid>
                    </Box>
                  </Card>
                </Grid>

                <Grid item xs={12}>
                  <Card sx={sectionCardStyle}>
                    <MDTypography variant="h6" fontWeight="bold" color="text.primary">
                      Contact Details & Acknowledgement
                    </MDTypography>
                    <MDTypography variant="caption" color="text.secondary">
                      Please fill in the following details which will be required to send you any related documents.
                    </MDTypography>
                    <Grid container spacing={2} sx={{ mt: 1 }}>
                      <Grid item xs={12} md={6}>
                        <RequiredLabel>Name</RequiredLabel>
                        <MDInput
                          fullWidth
                          name="employeeName"
                          value={formData.employeeName}
                          disabled
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <RequiredLabel>Email ID (Personal)</RequiredLabel>
                        <MDInput
                          fullWidth
                          name="personalEmail"
                          value={formData.personalEmail}
                          onChange={handleChange}
                          error={!!errors.personalEmail}
                          disabled={isApproved || isViewMode}
                          placeholder="example@email.com"
                        />
                        {errors.personalEmail && <Typography variant="caption" color="error">{errors.personalEmail}</Typography>}
                      </Grid>

                      <Grid item xs={12} md={4}>
                        <RequiredLabel>Phone no.</RequiredLabel>
                        <MDInput
                          fullWidth
                          name="phoneNumber"
                          value={formData.phoneNumber}
                          onChange={handleChange}
                          error={!!errors.phoneNumber}
                          disabled={isApproved || isViewMode}
                        />
                        {errors.phoneNumber && <Typography variant="caption" color="error">{errors.phoneNumber}</Typography>}
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <MDTypography variant="caption" color="text" fontWeight="medium">Alternate Phone</MDTypography>
                        <MDInput
                          fullWidth
                          name="alternatePhoneNumber"
                          value={formData.alternatePhoneNumber}
                          onChange={handleChange}
                          error={!!errors.alternatePhoneNumber}
                          disabled={isApproved || isViewMode}
                        />
                        {errors.alternatePhoneNumber && <Typography variant="caption" color="error">{errors.alternatePhoneNumber}</Typography>}
                      </Grid>

                      {/* Address Section */}
                      <Grid item xs={12}>
                        <MDTypography variant="subtitle2" fontWeight="bold" color="text.primary" sx={{ mt: 2, mb: 1 }}>
                          Permanent Address
                        </MDTypography>
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <RequiredLabel>Address Line 1</RequiredLabel>
                        <MDInput
                          fullWidth
                          name="addressLine1"
                          value={formData.addressLine1 || ''}
                          onChange={handleChange}
                          error={!!errors.addressLine1}
                          disabled={isApproved || isViewMode}
                          placeholder="House/Flat No., Building, Street"
                        />
                        {errors.addressLine1 && <Typography variant="caption" color="error">{errors.addressLine1}</Typography>}
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <MDTypography variant="caption" color="text" fontWeight="medium">Address Line 2 (Optional)</MDTypography>
                        <MDInput
                          fullWidth
                          name="addressLine2"
                          value={formData.addressLine2 || ''}
                          onChange={handleChange}
                          disabled={isApproved || isViewMode}
                          placeholder="Landmark, Area"
                        />
                      </Grid>

                      <Grid item xs={12} md={3}>
                        <FormControl fullWidth variant="standard" error={!!errors.country}>
                          <InputLabel shrink>
                            Country <span style={{ color: '#d32f2f' }}>*</span>
                          </InputLabel>
                          <Select
                            name="country"
                            value={formData.country || ''}
                            onChange={handleCountryChange}
                            disabled={isApproved || isViewMode}
                            displayEmpty
                          >
                            <MenuItem value="" disabled>
                              <em>Select Country</em>
                            </MenuItem>
                            {countries && countries.length > 0 ? (
                              countries.map(country => (
                                <MenuItem key={country.countryId} value={country.countryCode}>
                                  {country.countryName} ({country.countryCode})
                                </MenuItem>
                              ))
                            ) : (
                              <MenuItem disabled>No countries available</MenuItem>
                            )}
                          </Select>
                          {errors.country && (
                            <Typography variant="caption" color="error" sx={{ fontSize: '0.75rem', mt: 0.5 }}>
                              {errors.country}
                            </Typography>
                          )}
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} md={3}>
                        <FormControl fullWidth variant="standard" error={!!errors.state}>
                          <InputLabel shrink>
                            State <span style={{ color: '#d32f2f' }}>*</span>
                          </InputLabel>
                          <Select
                            name="state"
                            value={formData.state || ''}
                            onChange={handleStateChange}
                            disabled={isApproved || isViewMode || !formData.country}
                            displayEmpty
                          >
                            <MenuItem value="" disabled>
                              <em>Select State</em>
                            </MenuItem>
                            {states.map((state, index) => (
                              <MenuItem key={index} value={state.state}>
                                {state.state}
                              </MenuItem>
                            ))}
                          </Select>
                          {errors.state && (
                            <Typography variant="caption" color="error" sx={{ fontSize: '0.75rem', mt: 0.5 }}>
                              {errors.state}
                            </Typography>
                          )}
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} md={3}>
                        <FormControl fullWidth variant="standard" error={!!errors.city}>
                          <InputLabel shrink>
                            City <span style={{ color: '#d32f2f' }}>*</span>
                          </InputLabel>
                          <Select
                            name="city"
                            value={formData.city || ''}
                            onChange={handleCityChange}
                            disabled={isApproved || isViewMode || !formData.state}
                            displayEmpty
                          >
                            <MenuItem value="" disabled>
                              <em>Select City</em>
                            </MenuItem>
                            {cities.map((city, index) => (
                              <MenuItem key={index} value={city}>
                                {city}
                              </MenuItem>
                            ))}
                          </Select>
                          {errors.city && (
                            <Typography variant="caption" color="error" sx={{ fontSize: '0.75rem', mt: 0.5 }}>
                              {errors.city}
                            </Typography>
                          )}
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} md={3}>
                        <FormControl fullWidth variant="standard" error={!!errors.pincode}>
                          <InputLabel shrink>
                            Pincode <span style={{ color: '#d32f2f' }}>*</span>
                          </InputLabel>
                          <Input
                            fullWidth
                            name="pincode"
                            value={formData.pincode || ''}
                            onChange={handleChange}
                            disabled={isApproved || isViewMode}
                            placeholder="6-digit pincode"
                            sx={{ mt: 0 }}
                          />
                          {errors.pincode && (
                            <Typography variant="caption" color="error" sx={{ fontSize: '0.75rem', mt: 0 }}>
                              {errors.pincode}
                            </Typography>
                          )}
                        </FormControl>
                      </Grid>

                      <Grid item xs={12}>
                        <SignatureUpload section="employee" label="Employee Signature" disabled={isViewMode} />
                        {errors.signature && (
                          <Typography variant="caption" color="error" sx={{ mt: 0.5, display: 'block' }}>
                            {errors.signature}
                          </Typography>
                        )}
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
                {!isViewMode && (
                  <MDBox mt={2} mb={1} display="flex" gap={2} justifyContent="flex-end">

                    {/* Save as Draft Button */}
                    {!isApproved && (
                      <MDButton
                        variant="outlined"
                        color="secondary"
                        onClick={() => {
                          // setIdDraft("draft");      // <-- SET VALUE
                          handleSaveDraft();
                        }}
                        disabled={loading || isViewMode}
                        sx={{ py: 1.5, fontSize: '1rem', minWidth: 200 }}
                      >
                        {loading && isDraftSaving ? (
                          <>
                            <CircularProgress size={20} color="inherit" sx={{ mr: 1 }} />
                            Saving Draft...
                          </>
                        ) : (
                          'Save as Draft'
                        )}
                      </MDButton>
                    )}

                    {/* Submit Button */}
                    <MDButton
                      variant="gradient"
                      color="info"
                      fullWidth={!isApproved}
                      type="submit"
                      // onClick={() => {
                      //   setIdDraft(isAlreadySubmitted ? "update" : "submit"); // <-- SET VALUE
                      // }}
                      disabled={loading || isApproved || isViewMode}
                      sx={{ background: properties.colors.bgcolorbluethem, py: 1.5, fontSize: '1rem' }}
                    >
                      {loading && !isDraftSaving ? (
                        <>
                          <CircularProgress size={20} color="inherit" sx={{ mr: 1 }} />
                          {isAlreadySubmitted ? 'Updating...' : 'Submitting...'}
                        </>
                      ) : isApproved ? (
                        'Form Approved - No Edits Allowed'
                      ) : (
                        isAlreadySubmitted ? 'Update & Submit' : 'Submit Exit Clearance'
                      )}
                    </MDButton>

                  </MDBox>

                )}

              </Grid>
            </form>

            <Snackbar open={snackOpen} anchorOrigin={{ vertical: 'top', horizontal: 'right' }} autoHideDuration={3000} onClose={() => setSnackOpen(false)}>
              <Alert onClose={() => setSnackOpen(false)} severity={snackColor === 'success' ? 'success' : 'error'} variant="filled" sx={{ width: '100%', color: '#fff' }}>
                {snackMessage}
              </Alert>
            </Snackbar>
          </MDBox>
        </Card>

        <Box mt={2} mb={4} textAlign="center">
          <Typography variant="caption" color="text.secondary">
            BNT SOFT PVT. LTD. Office No. 301-304, &quot;A&quot; Building, Pune IT Park, 34, Aundh Road, Bhau Patil Marg, Bopodi, Pune-411020, Maharashtra, India. Web: www.bnt-soft.com
          </Typography>
        </Box>
      </MDBox>
      {/* Confirmation Dialog */}
      <Dialog open={confirmDialogOpen} onClose={() => setConfirmDialogOpen(false)}>
        <DialogTitle>Confirm Submission</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {isAlreadySubmitted ? (
              <>
                Are you sure you want to update and submit this Exit Clearance Form?<br /><br />
                <strong>This will update your previously submitted form.</strong>
              </>
            ) : (
              <>
                Are you sure you want to submit this Exit Clearance Form?<br /><br />
                <strong>Once submitted, you will NOT be able to edit this form again.</strong>
              </>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmDialogOpen(false)}>Cancel</Button>
          <Button
            onClick={handleFinalSubmit}
            variant="contained"
            color="primary"
            sx={{ color: '#fff' }}
            autoFocus
          >
            Yes, Submit
          </Button>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
};

export default ExitClearanceForm;